import { FC, useEffect, useRef, useState } from "react";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import React from "react";
import { PromptHint } from "../model/PromptHint";
import { GenerationRequest } from "../model/GenerationRequest";

import { getAccountId, isLoggedIn, saveToken } from "../services/CookieHandler";
import toast, { Toaster, useToaster } from "react-hot-toast";
import { CardRegistrationDialog, CardRegistrationDialogProps } from "../parts/CardRegisterDialog";
import { StripeCard } from "../model/StripeCard";
import { SetupIntentResponse } from "../model/SetupIntentResponse";
import { SubscriptionRecommendDialog } from "../parts/SubscriptionRecommendDialog";
import { FlatPromptHint } from "../model/FlatPromptHint";
import { ModelTaste } from "../model/ModelTaste";
import { LoginDialog } from "../parts/LoginDialog";
import { UNSAFE_DataRouterStateContext, useLocation, useNavigate } from "react-router-dom";
import { Inspiration } from "../model/Inspiration";
import { AspectRatio } from "../model/AspectRatio";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Button, Center, Checkbox, Collapse, Group, Loader, Modal, NumberInput, Radio, RadioGroup, Slider, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useHeaderStore } from "../parts/CommonHeader";
import { RemainCountResponse } from "../model/RemainCountResponse";
import { SubscriptionDialog } from "../parts/SubscriptionDialog";
import { SubscriptionDialogProps } from "../parts/SubscriptionDialog";
import { getNextPlanId } from "../services/SubscriptionService";
import { convertToObject } from "typescript";
import { InspirationDialog } from "../parts/InspirationDialog";
import { Helmet } from "react-helmet";
import { getModalOffset } from "../services/ScreenUtil";
import ImageUploader, { ImageUploaderHandle } from "../parts/ImageUploader";
import { SkyFlagDialog } from "../parts/SkyFlagDialog";
import { SkyFlagRewardDialog } from "../parts/SkyFlagRewardDialog";
import { SkyDialogResponse } from "../model/SkyDialogResponse";
import { getSkyFlagUrl } from "../services/SkyFlagUtil";
import { FooterMenu } from "../components/FooterMenu";
import iconImageAdd from "../img/icon-image-add.png";
import iconAdjust from "../img/icon-adjust.png";
import iconEnToJpGray from "../img/icon-en-to-jp-gray.png";
import bananaIcon from "../img/banana-icon.png";
const TRANSLATION_INTRO_KEY = 'translation-intro-shown';
const GENERATE_INTRO_KEY = 'generate-intro-shown';
const MOBILE_HEADER_HEIGHT = 76;
class FlatPromptResponse {
  largeCategories: string[] = [];
  middleCategories: FlatPromptHint[] = [];
  list: FlatPromptHint[] = [];
}

type PrefillPromptState = {
  prefillPrompt?: string;
  prefillNegativePrompt?: string;
  prefillTasteName?: string;
  prefillGenerationModelType?: GenerationModelType;
  prefillNanoTimelineId?: string;
  prefillReferenceImageUrl?: string;
  prefillReferenceRequestId?: string;
  prefillReferenceSampleFileName?: string;
};

type GenerationModelType = "standard" | "nano-banana" | "nano-banana-pro";
type ProcessingMode = "standard" | "nano-banana";
type PlanTier = "free" | "lite" | "standard" | "advanced";

type GeminiTimelineItem = {
  role: "user" | "model" | "system";
  text?: string;
  imageDataUrl?: string;
  imageDataUrls?: string[];
  createdAt: number;
};

type GeminiGenerateApiResponse = {
  code?: number;
  message?: string;
  timelineId?: string;
  TimelineId?: string;
  aspectRatio?: string;
  AspectRatio?: string;
  imageSize?: string;
  ImageSize?: string;
  text?: string;
  Text?: string;
  imageBase64?: string;
  ImageBase64?: string;
  imageMimeType?: string;
  ImageMimeType?: string;
};

const GEMINI_FLASH_IMAGE_MODEL = "gemini-2.5-flash-image";
const GEMINI_PRO_IMAGE_MODEL = "gemini-3-pro-image-preview";
const NANO_GEMINI_ALLOWED_ASPECT_RATIOS = ["1:1", "2:3", "3:2", "9:16", "16:9", "21:9"];

function resolveImagePathToSrc(imagePath?: string): string | undefined {
  if (!imagePath) return undefined;
  if (/^https?:\/\//i.test(imagePath)) return imagePath;
  if (!process.env.REACT_APP_IMAGE_URL) return undefined;
  return `${process.env.REACT_APP_IMAGE_URL}/${imagePath}`;
}

function resolvePlanTierFromInternalProductId(internalProductId?: string): PlanTier {
  const value = (internalProductId ?? "").toLowerCase();
  if (value.startsWith("advanced")) return "advanced";
  if (value.startsWith("standard")) return "standard";
  if (value.startsWith("lite")) return "lite";
  return "free";
}

function getStandardConsumingPoint(planTier: PlanTier): number {
  if (planTier === "advanced") return 2;
  if (planTier === "lite" || planTier === "standard") return 3;
  return 5;
}

function getNanoBananaConsumingPoint(planTier: PlanTier): number {
  if (planTier === "advanced") return 8;
  if (planTier === "standard") return 9;
  return 10;
}

function getNanoBananaProConsumingPoint(planTier: PlanTier, imageSize: string): number | undefined {
  if (imageSize === "4K") {
    return planTier === "advanced" ? 58 : undefined;
  }
  if (planTier === "advanced") return 34;
  if (planTier === "lite") return 38;
  if (planTier === "standard") return 36;
  return undefined;
}

type GeminiTimelineSummary = {
  timelineId: string;
  TimelineId?: string;
  modelName: string;
  ModelName?: string;
  aspectRatio?: string;
  AspectRatio?: string;
  imageSize?: string;
  ImageSize?: string;
  lastText?: string;
  LastText?: string;
  lastImageId?: string;
  LastImageId?: string;
  lastImagePath?: string;
  LastImagePath?: string;
  lastImageBase64?: string;
  LastImageBase64?: string;
  lastImageMimeType?: string;
  LastImageMimeType?: string;
  images?: Array<{
    imageId?: string;
    ImageId?: string;
    imagePath?: string;
    ImagePath?: string;
    imageMimeType?: string;
    ImageMimeType?: string;
  }>;
  Images?: Array<{
    imageId?: string;
    ImageId?: string;
    imagePath?: string;
    ImagePath?: string;
    imageMimeType?: string;
    ImageMimeType?: string;
  }>;
  updatedDate?: string;
  UpdatedDate?: string;
};

type GeminiTimelineDetailApiResponse = {
  code?: number;
  Code?: number;
  message?: string;
  Message?: string;
  timelineId?: string;
  TimelineId?: string;
  modelName?: string;
  ModelName?: string;
  aspectRatio?: string;
  AspectRatio?: string;
  imageSize?: string;
  ImageSize?: string;
  messages?: Array<{
    role: "user" | "model" | "system";
    Role?: "user" | "model" | "system";
    text?: string;
    Text?: string;
    imageBase64?: string;
    ImageBase64?: string;
    imageMimeType?: string;
    ImageMimeType?: string;
    images?: Array<{
      imageBase64?: string;
      ImageBase64?: string;
      imageMimeType?: string;
      ImageMimeType?: string;
      imagePath?: string;
      ImagePath?: string;
    }>;
    Images?: Array<{
      imageBase64?: string;
      ImageBase64?: string;
      imageMimeType?: string;
      ImageMimeType?: string;
      imagePath?: string;
      ImagePath?: string;
    }>;
    createdDate?: string;
    CreatedDate?: string;
  }>;
  Messages?: Array<{
    role?: "user" | "model" | "system";
    Role?: "user" | "model" | "system";
    text?: string;
    Text?: string;
    imageBase64?: string;
    ImageBase64?: string;
    imageMimeType?: string;
    ImageMimeType?: string;
    images?: Array<{
      imageBase64?: string;
      ImageBase64?: string;
      imageMimeType?: string;
      ImageMimeType?: string;
      imagePath?: string;
      ImagePath?: string;
    }>;
    Images?: Array<{
      imageBase64?: string;
      ImageBase64?: string;
      imageMimeType?: string;
      ImageMimeType?: string;
      imagePath?: string;
      ImagePath?: string;
    }>;
    createdDate?: string;
    CreatedDate?: string;
  }>;
};

type ReferenceImageApiResponse = {
  code?: number;
  Code?: number;
  message?: string;
  Message?: string;
  imageBase64?: string;
  ImageBase64?: string;
  imageMimeType?: string;
  ImageMimeType?: string;
};

export const ImageGenerationPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const search = location.search;
  const query = new URLSearchParams(search);
  const inspirationNumber = query.get('inspiration-number');
  const prefillReferenceImageUrlFromQuery = query.get('prefill-reference-image-url');
  const prefillReferenceRequestIdFromQuery = query.get('prefill-reference-request-id');
  const prefillReferenceSampleFileFromQuery = query.get('prefill-reference-sample-file');
  
  const [ratioList, setRatioList] = useState<AspectRatio[]>([]);
  const [selectedLargeCategory, setSelectedLargeCategory] = useState("");
  const [selectedHint, setSelectedHint] = useState<FlatPromptHint[]>([]);
  const [largeCategories, setLargeCategories] = useState<string[]>([]);
  const [negativelargeCategories, setNegativeLargeCategories] = useState<string[]>([]);
  const [inspirationList, setInspirationList] = useState<Inspiration[]>([]);

  const [middleCategories, setMiddleCategories] = useState<FlatPromptHint[]>([]);
  const [hintList, setHintList] = useState<FlatPromptHint[]>([]);
  const [negativeHintList, setNegativeHintList] = useState<FlatPromptHint[]>([]);
  
  const [mainTasteList, setMainTasteList] = useState<ModelTaste[]>([]);
  const [selectedModel, setSelectedModel] = useState<ModelTaste[]>([]);
  const [currentPrompt, setCurrentPrompt] = useState('');
  const [currentNegativePrompt, setCurrentNegativePrompt] = useState('');
  
  const [requestList, setRequestList] = useState<GenerationRequest[]>([]);
  const [nanoTimelineHistory, setNanoTimelineHistory] = useState<GeminiTimelineSummary[]>([]);
  const [processing, setProcessing] = useState(false);
  const [generationModelType, setGenerationModelType] = useState<GenerationModelType>("standard");
  const [modelSelectorOpened, setModelSelectorOpened] = useState(false);
  const [processingMode, setProcessingMode] = useState<ProcessingMode>("standard");
  const [nanoTimelineId, setNanoTimelineId] = useState<string | undefined>(undefined);
  const [nanoTimelineAspectRatio, setNanoTimelineAspectRatio] = useState<string>("1:1");
  const [nanoTimelineImageSize, setNanoTimelineImageSize] = useState<string>("1K");
  const [nanoTimelineItems, setNanoTimelineItems] = useState<GeminiTimelineItem[]>([]);
  const [nanoTimelineGeneratedAt, setNanoTimelineGeneratedAt] = useState<number | undefined>(undefined);
  const [nanoGenerating, setNanoGenerating] = useState(false);
  const [nanoFollowupText, setNanoFollowupText] = useState("");
  const nanoFollowupTextareaRef = useRef<HTMLTextAreaElement | null>(null);
  const [processingDialogTab, setProcessingDialogTab] = useState<"basic" | "timeline">("basic");
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [imageSize, setImageSize] = useState('1K');
  const [fileFomat, setFileFomat] = useState('jpeg');
  const [bulkCount, setBulkCount] = useState(1);
  const [additionalPrompt, setAdditionalPrompt] = useState('');
  const [additionalNegativePrompt, setAdditionalNegativePrompt] = useState('');
  const [seed, setSeed] = useState('');
  const [stepCount, setStepCount] = useState(20);
  const [scale, setScale] = useState(7.5);
  const [strength, setStrength] = useState(0.6);
  // const [loginFlag, setLoginFlag] = useState(isLoggedIn());
  const [keyword, setKeyword] = useState('');
  const [cardProps, setCardProps] = useState<CardRegistrationDialogProps | undefined>(undefined);
  const selectedItems = useRef<PromptHint[]>([]);

  const [searchText, setSeachText] = useState('');
  const [promptSearchResult, setPromptSearchResult] = useState<FlatPromptHint[]>([]);
  
  const [negativeSearchText, setNegativeSearchText] = useState('');
  const [negativePromptSearchResult, setNegativePromptSearchResult] = useState<FlatPromptHint[]>([]);

  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const [generationRequest, setGenerationRequest] = useState<GenerationRequest| undefined>(undefined);

  const opened = true;
  const openedPrompt = true;
  const [openedDetail, { toggle: toggleDetail }] = useDisclosure(true);
  const onClickToggleDetail = async () => {
    // 詳細設定を開く直前に最新のプラン/残回数を取得して制約を反映
    try {
      if (isLoggedIn) {
        console.log('[PlanRefresh] 詳細設定 open -> fetchActiveSubscription + fetchRemainCount');
        await useHeaderStore.getState().fetchActiveSubscription();
        await useHeaderStore.getState().fetchRemainCount();
      }
    } catch (e) {
      console.log('[PlanRefresh] 詳細設定 refresh error', e);
    }
    toggleDetail();
  };
  const [openedNegative, { toggle: toggleNegative }] = useDisclosure(false);
  const [mobileNegativeVisible, setMobileNegativeVisible] = useState(false);
  const [mobileSettingsVisible, setLocalMobileSettingsVisible] = useState(false);
  
  const { remainCount, setRemainCount, subscription, card, fetchRemainCount, fetchActiveSubscription, onLogin, isLoggedIn, setIsLoggedIn, screenWidth, setMobileSettingsVisible, setProcessingDialogVisible, headerHidden, account, fetchAccount } = useHeaderStore();
  const [subscriptionDialogProps, setSubscriptionDialogProps] = useState<SubscriptionDialogProps | undefined>(undefined);
  const [subscriptionDialogOpened, { open: openSubscriptionDialog, close: closeSubscriptionDialog }] = useDisclosure(false);
  const [skyFlagDialogOpened, { open: openSkyFlagDialog, close: closeSkyFlagDialog }] = useDisclosure(false);
  const [skyFlagRewardDialogOpened, { open: openSkyFlagRewardDialog, close: closeSkyFlagRewardDialog }] = useDisclosure(false);

  const [processingDialogOpened, { open: openProcessingDialog, close: closeProcessingDialog }] = useDisclosure(false);
  const [previewImageDataUrl, setPreviewImageDataUrl] = useState<string | undefined>(undefined);
  const [processingMultiDialogOpened, { open: openProcessingMultiDialog, close: closeProcessingMultiDialog }] = useDisclosure(false);
  const [promptDialogOpened, setPromptDialogOpened] = useState<boolean>(false);
  const [inspiration, setInspiration] = useState<Inspiration | undefined>(undefined);
  const [inspirationDialogOpened, { open: openInspirationDialog, close: closeInspirationDialog }] = useDisclosure(false);
  const [thisPromptButtonVisible, setThisPromptButtonVisible] = useState(false);
  const [bulkCountOption, setBulkCountOption] = useState([1]);
  const [isPromptTranslating, setIsPromptTranslating] = useState(false);
  const [isNegativePromptTranslating, setIsNegativePromptTranslating] = useState(false);
  const [base64, setBase64] = useState('');
  const [nanoInputImages, setNanoInputImages] = useState<string[]>([]);
  const [resizeMode, setResizeMode] = useState('ResizeAndFill');
  const [pendingTasteName, setPendingTasteName] = useState<string | undefined>(undefined);
  const imageUploaderRef = useRef<ImageUploaderHandle | null>(null);
  const [translationIntroOpened, setTranslationIntroOpened] = useState(false);
  const [translationIntroEverShown, setTranslationIntroEverShown] = useState(false);
  const [generateIntroOpened, setGenerateIntroOpened] = useState(false);
  const [generateIntroEverShown, setGenerateIntroEverShown] = useState(false);
  const [mobilePromptHeight, setMobilePromptHeight] = useState(0);
  const [img2imgAgreeVisible, setImg2imgAgreeVisible] = useState(false);
  const [img2imgAgreeChecked, setImg2imgAgreeChecked] = useState(false);
  const [img2imgAgreeLoading, setImg2imgAgreeLoading] = useState(false);
  const mobilePromptRef = useRef<HTMLDivElement | null>(null);
  const mobilePromptTop = headerHidden ? 0 : MOBILE_HEADER_HEIGHT;
  const mobileContentOffset = screenWidth < 640 ? mobilePromptHeight : 0;

  useEffect(() => {
    if (screenWidth >= 640) return;

    const resizeObserver = new ResizeObserver(() => {
      if (mobilePromptRef.current) {
        setMobilePromptHeight(mobilePromptRef.current.offsetHeight);
      }
    });

    if (mobilePromptRef.current) {
      resizeObserver.observe(mobilePromptRef.current);
      setMobilePromptHeight(mobilePromptRef.current.offsetHeight);
    }

    return () => resizeObserver.disconnect();
  }, [screenWidth]);

  useEffect(() => {
    if (isLoggedIn) {
      fetchAccount();
    }
  }, [isLoggedIn, fetchAccount]);

  useEffect(() => {
    const state = location.state as PrefillPromptState | null;
    const referenceImageUrl = state?.prefillReferenceImageUrl ?? prefillReferenceImageUrlFromQuery ?? undefined;
    const referenceRequestId = state?.prefillReferenceRequestId ?? prefillReferenceRequestIdFromQuery ?? undefined;
    const referenceSampleFileName = state?.prefillReferenceSampleFileName ?? prefillReferenceSampleFileFromQuery ?? undefined;
    if (!(state?.prefillPrompt || state?.prefillNegativePrompt || state?.prefillTasteName || state?.prefillGenerationModelType || state?.prefillNanoTimelineId || referenceImageUrl || referenceRequestId || referenceSampleFileName)) {
      return;
    }

    let cancelled = false;
    const applyPrefill = async () => {
      setSelectedHint([]);
      if (typeof state?.prefillPrompt === 'string') {
        setAdditionalPrompt(state.prefillPrompt);
      }
      if (typeof state?.prefillNegativePrompt === 'string') {
        setAdditionalNegativePrompt(state.prefillNegativePrompt);
      }
      if (typeof state?.prefillTasteName === 'string') {
        setPendingTasteName(state.prefillTasteName);
      }
      if (state?.prefillGenerationModelType === "standard" || state?.prefillGenerationModelType === "nano-banana" || state?.prefillGenerationModelType === "nano-banana-pro") {
        setGenerationModelType(state.prefillGenerationModelType);
      }

      if (typeof state?.prefillNanoTimelineId === "string" && state.prefillNanoTimelineId !== "") {
        const fallbackModelName = state.prefillGenerationModelType === "nano-banana-pro"
          ? GEMINI_PRO_IMAGE_MODEL
          : GEMINI_FLASH_IMAGE_MODEL;
        await openNanoTimelineFromHistory({
          timelineId: state.prefillNanoTimelineId,
          modelName: fallbackModelName,
          aspectRatio: "1:1",
          imageSize: "1K",
        });
      }

      if (typeof referenceRequestId === "string" && referenceRequestId !== "") {
        onSetBase64(`${process.env.REACT_APP_IMAGE_URL}/${referenceRequestId}`);
        try {
          const response = await fetchAsync<ReferenceImageApiResponse>('Generation/GetReferenceImageBase64', {
            requestId: referenceRequestId
          });
          const imageBase64 = response.imageBase64 ?? response.ImageBase64;
          const imageMimeType = response.imageMimeType ?? response.ImageMimeType;
          if (imageBase64 && imageMimeType) {
            onSetBase64(`data:${imageMimeType};base64,${imageBase64}`);
          }
        } catch {
          // ignore reference image fetch errors
        }
      } else if (typeof referenceSampleFileName === "string" && referenceSampleFileName !== "") {
        onSetBase64(`${process.env.REACT_APP_IMAGE_URL}/sample/${referenceSampleFileName}`);
        try {
          const response = await fetchAsync<ReferenceImageApiResponse>('Generation/GetReferenceImageBase64', {
            sampleFileName: referenceSampleFileName
          });
          const imageBase64 = response.imageBase64 ?? response.ImageBase64;
          const imageMimeType = response.imageMimeType ?? response.ImageMimeType;
          if (imageBase64 && imageMimeType) {
            onSetBase64(`data:${imageMimeType};base64,${imageBase64}`);
          }
        } catch {
          // ignore reference image fetch errors
        }
      } else if (typeof referenceImageUrl === "string" && referenceImageUrl !== "") {
        onSetBase64(referenceImageUrl);
        try {
          const dataUrl = await convertImageSourceToDataUrl(referenceImageUrl);
          if (dataUrl) onSetBase64(dataUrl);
        } catch {
          // ignore prefill reference image errors
        }
      }

      if (!cancelled) {
        const params = new URLSearchParams(location.search);
        params.delete('prefill-reference-image-url');
        params.delete('prefill-reference-request-id');
        params.delete('prefill-reference-sample-file');
        const nextSearch = params.toString();
        const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
        navigate(nextUrl, { replace: true });
      }
    };

    applyPrefill();
    return () => {
      cancelled = true;
    };
  }, [location.state, location.pathname, location.search, navigate, prefillReferenceImageUrlFromQuery, prefillReferenceRequestIdFromQuery, prefillReferenceSampleFileFromQuery]);

  useEffect(() => {
    if (!pendingTasteName || mainTasteList.length === 0) return;
    const taste = mainTasteList.find((t) => t.name === pendingTasteName || t.modelName === pendingTasteName);
    if (taste) {
      setSelectedModel([taste]);
      setPendingTasteName(undefined);
    }
  }, [pendingTasteName, mainTasteList]);

  useEffect(() => {
    const fetchHintList = async () => {
      const response = await fetchAsync<FlatPromptResponse>('FlatPromptHint/GetList');
      setLargeCategories(response.largeCategories.filter((e) => !e.startsWith('ネガティブプロンプト')));
      setMiddleCategories(response.middleCategories);
      setHintList(response.list.filter((e) => e.isNegativePrompt === false));
      setNegativeHintList(response.list.filter((e) => e.isNegativePrompt === true));
      setNegativeLargeCategories(response.largeCategories.filter((e) => e.startsWith('ネガティブプロンプト')));
    };

    //setDefaultPrompt();
    fetchInspirationList();
    fetchHintList();
    init();

    if (isLoggedIn) {
      const intervalId = setInterval(fetchSkyFlag, 10000);
      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn])

  async function fetchSkyFlag(){
    const response = await fetchAsync<SkyDialogResponse>('SkyFlag/GetDialogFlag');
    if(response.data === true){
      fetchRemainCount();
      openSkyFlagRewardDialog();
    }
  }

  async function init(){
    if(isLoggedIn === true){
      fetchGeneratedList();
      fetchGeminiTimelineList();
    }
    await fetchMainTasteList();
    setSamplaPrompt();
    fetchRatioList();
  }

  useEffect(() => {
    if(subscription?.internalProductId.startsWith('lite') || subscription?.internalProductId.startsWith('standard') || subscription?.internalProductId.startsWith('advanced')) {
      setBulkCountOption([1, 2, 4]);
      setBulkCount(2);
    }
  }, [subscription])

  // タブを開く（フォーカス/再表示）たびに現在のプランを再取得
  useEffect(() => {
    const refreshPlan = () => {
      try {
        console.log('[PlanRefresh] focus/pageshow/visibility -> fetchActiveSubscription');
        // 非ログイン時はAPIコールを避ける
        if (!isLoggedIn) return;
        // 常に最新のstoreから取得（関数参照の変化に影響されない）
        useHeaderStore.getState().fetchActiveSubscription();
      } catch (e) {
        console.log('[PlanRefresh] focus/pageshow/visibility fetch error', e);
      }
    };
    const onFocus = () => refreshPlan();
    const onPageShow = () => refreshPlan();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshPlan();
    };
    window.addEventListener('focus', onFocus);
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('visibilitychange', onVisibilityChange);
    // 初回マウント時に一度同期
    if (document.visibilityState === 'visible') refreshPlan();
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [isLoggedIn]);

  // ルート遷移で画像生成ページが表示されたタイミングでも再取得
  useEffect(() => {
    try {
      if (location.pathname === '/image-generation') {
        console.log('[PlanRefresh] route enter image-generation -> fetchActiveSubscription + fetchRemainCount');
        if (isLoggedIn) {
          useHeaderStore.getState().fetchActiveSubscription();
          useHeaderStore.getState().fetchRemainCount();
        }
      } else {
        console.log('[PlanRefresh] route change (not image-generation):', location.pathname);
      }
    } catch (e) {
      console.log('[PlanRefresh] route enter refresh error', e);
    }
  }, [location.pathname]);

  // 初回マウント時も必ず取得
  useEffect(() => {
    try {
      console.log('[PlanRefresh] mount image-generation -> fetchActiveSubscription + fetchRemainCount');
      if (isLoggedIn) {
        useHeaderStore.getState().fetchActiveSubscription();
        useHeaderStore.getState().fetchRemainCount();
      }
    } catch (e) {
      console.log('[PlanRefresh] mount refresh error', e);
    }
  }, []);

  useEffect(() => {
    if(isLoggedIn === true){
      onLoginEvent();
    }
  },[isLoggedIn]);

  React.useEffect(() => {
    if (isLoggedIn === false) {
      return;
    }

    const id = setInterval(() => {
      var startedCount = requestList.filter((e) => e.status === 'started').length;
      if(startedCount == 0) {
        return;
      }
      fetchGeneratedList();
      fetchRemainCount();
    }, 1000);
    return () => clearInterval(id);
  }, [requestList]);

  async function setSamplaPrompt(){

    if(inspirationNumber === null || inspirationNumber === ''){
      return;
    }

    var param = { inspirationNumber: inspirationNumber };
    const response = await fetchAsync<Inspiration>('Inspiration/GetSingle', param);
    const list = await fetchAsync<ModelTaste[]>('ModelTaste/GetList');

    var taste = list.filter((e) => e.modelName == response.modelTaste)[0];

    var tasteList = [];
    tasteList.push(taste);
    setSelectedModel(tasteList);
    setAdditionalPrompt(response.prompt);
    setAdditionalNegativePrompt(response.negativePrompt);
  }

  const updateMobileSettingsVisible = async (visible: boolean) => {
    if (visible && isLoggedIn) {
      try {
        console.log('[PlanRefresh] モバイル画像設定 open -> fetchActiveSubscription + fetchRemainCount');
        await useHeaderStore.getState().fetchActiveSubscription();
        await useHeaderStore.getState().fetchRemainCount();
      } catch (e) {
        console.log('[PlanRefresh] モバイル画像設定 refresh error', e);
      }
    }
    setLocalMobileSettingsVisible(visible);
    setMobileSettingsVisible(visible);
  };

  const openProcessingDialogWithHeader = () => {
    openProcessingDialog();
    setProcessingDialogVisible(true);
  };

  const closeProcessingDialogWithHeader = () => {
    closeProcessingDialog();
    setProcessingDialogVisible(false);
    if (processingMode === "nano-banana") {
      setNanoTimelineId(undefined);
      setNanoTimelineAspectRatio("1:1");
      setNanoTimelineImageSize("1K");
      setNanoTimelineGeneratedAt(undefined);
      setNanoTimelineItems([]);
      setNanoFollowupText("");
      setNanoInputImages([]);
      setNanoGenerating(false);
      setProcessing(false);
      setProcessingDialogTab("basic");
    }
  };

  async function fetchInspirationList() {
    var params = {
      page: 0,
      count: 100
    };
    const response = await fetchAsync<Inspiration[]>('Inspiration/GetList', params);
    response.sort(() => Math.random() - 0.5);
    setInspirationList(response);
  };

  async function fetchMainTasteList (){
    const list = await fetchAsync<ModelTaste[]>('ModelTaste/GetList');
    setMainTasteList(list);
  };

  async function fetchGeneratedList (){
    var param = {
      count: 20, 
      page: 0,
      asc: false,
      containsNsfw: true,
      containsError: true,
    };
    const list = await fetchAsync<GenerationRequest[]>('Generation/GetGeneratedImages', param);
    setRequestList(list);
    if(list.length >= 1) {
      setGenerationRequest(list[0]);
    }

  };

  async function fetchGeminiTimelineList() {
    if (!isLoggedIn) {
      setNanoTimelineHistory([]);
      return;
    }

    try {
      const list = await fetchAsync<GeminiTimelineSummary[]>('Generation/GetGeminiTimelineList', {
        page: 0,
        count: 20
      });
      const normalized = (list ?? []).map((item) => ({
        timelineId: item.timelineId ?? item.TimelineId ?? "",
        modelName: item.modelName ?? item.ModelName ?? GEMINI_FLASH_IMAGE_MODEL,
        aspectRatio: item.aspectRatio ?? item.AspectRatio ?? "1:1",
        imageSize: item.imageSize ?? item.ImageSize,
        lastText: item.lastText ?? item.LastText,
        lastImageId: item.lastImageId ?? item.LastImageId,
        lastImagePath: item.lastImagePath ?? item.LastImagePath,
        lastImageBase64: item.lastImageBase64 ?? item.LastImageBase64,
        lastImageMimeType: item.lastImageMimeType ?? item.LastImageMimeType,
        images: (item.images ?? item.Images ?? []).map((img) => ({
          imageId: img.imageId ?? img.ImageId,
          imagePath: img.imagePath ?? img.ImagePath,
          imageMimeType: img.imageMimeType ?? img.ImageMimeType
        })),
        updatedDate: item.updatedDate ?? item.UpdatedDate
      })).filter((e) => e.timelineId !== "");
      setNanoTimelineHistory(normalized);
    } catch {
      // ignore history fetch errors
    }
  }

  async function fetchRatioList (){
    const list = await fetchAsync<AspectRatio[]>('AspectRatio/GetList');
    setRatioList(list);
  };

  function buildGeminiPromptText() {
    const promptText = `${currentPrompt} ${additionalPrompt}`.trim();
    const negativeText = `${currentNegativePrompt} ${additionalNegativePrompt}`.trim();
    if (negativeText.length > 0) {
      return `${promptText}\n\nNegative prompt: ${negativeText}`;
    }
    return promptText;
  }

  async function convertImageSourceToDataUrl(imageSource: string): Promise<string | undefined> {
    if (!imageSource) return undefined;
    if (imageSource.startsWith("data:")) return imageSource;

    if (imageSource.startsWith(`${process.env.REACT_APP_IMAGE_URL}/sample/`)) {
      const sampleFileName = imageSource.substring(`${process.env.REACT_APP_IMAGE_URL}/sample/`.length);
      if (sampleFileName) {
        const response = await fetchAsync<ReferenceImageApiResponse>('Generation/GetReferenceImageBase64', {
          sampleFileName
        });
        const imageBase64 = response.imageBase64 ?? response.ImageBase64;
        const imageMimeType = response.imageMimeType ?? response.ImageMimeType;
        if (imageBase64 && imageMimeType) {
          return `data:${imageMimeType};base64,${imageBase64}`;
        }
      }
    }

    if (imageSource.startsWith(`${process.env.REACT_APP_IMAGE_URL}/`)) {
      const requestId = imageSource.substring(`${process.env.REACT_APP_IMAGE_URL}/`.length).split('/')[0];
      if (requestId && !requestId.includes('_mid')) {
        const response = await fetchAsync<ReferenceImageApiResponse>('Generation/GetReferenceImageBase64', {
          requestId
        });
        const imageBase64 = response.imageBase64 ?? response.ImageBase64;
        const imageMimeType = response.imageMimeType ?? response.ImageMimeType;
        if (imageBase64 && imageMimeType) {
          return `data:${imageMimeType};base64,${imageBase64}`;
        }
      }
    }

    try {
      const response = await fetch(imageSource);
      if (!response.ok) return undefined;
      const blob = await response.blob();
      const dataUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve((reader.result as string) ?? "");
        reader.onerror = () => reject(new Error("参照画像の変換に失敗しました。"));
        reader.readAsDataURL(blob);
      });
      return dataUrl || undefined;
    } catch {
      return undefined;
    }
  }

  async function buildNanoBananaImage() {
    const promptText = buildGeminiPromptText();

    if (isLoggedIn === false) {
      openLoginDialog();
      return;
    }

    if (processing) {
      return;
    }

    if (generationModelType === "nano-banana-pro" && !canSelectNanoBananaPro) {
      toast.error("Nano Banana Pro は Lite / Standard / Advanced プランで利用できます。");
      return;
    }

    if (generationModelType === "nano-banana-pro" && !allowedNanoProImageSizes.includes(imageSize)) {
      toast.error("現在のプランでは選択中の Nano Banana Pro 画像サイズは利用できません。");
      return;
    }

    const sourceImages = nanoInputImages.length > 0
      ? nanoInputImages
      : (base64 ? [base64] : []);
    const requestImages = (await Promise.all(sourceImages.map((img) => convertImageSourceToDataUrl(img)))).filter((img): img is string => !!img);
    if (promptText === '' && requestImages.length === 0) {
      toast.error("プロンプトまたは画像を指定してください");
      return;
    }

    setProcessingMode("nano-banana");
    setProcessingDialogTab("timeline");
    setNanoTimelineAspectRatio(aspectRatio);
    setNanoTimelineImageSize(imageSize);
    openProcessingDialogWithHeader();
    await sendNanoTimelineMessage(promptText || undefined, requestImages);
  }

  async function sendNanoTimelineMessage(text?: string, imageBase64List?: string[]) {
    const normalizedText = text?.trim() || "";
    const normalizedImages = (imageBase64List ?? [])
      .filter((img) => !!img && img.trim() !== "");
    if (normalizedText === "" && normalizedImages.length === 0) {
      return;
    }

    if (nanoGenerating || processing) {
      return;
    }

    setProcessing(true);
    setNanoGenerating(true);

    const userTimelineItem: GeminiTimelineItem = {
      role: "user",
      text: normalizedText || undefined,
      imageDataUrl: normalizedImages.length > 0 ? normalizedImages[0] : undefined,
      imageDataUrls: normalizedImages.length > 0 ? normalizedImages : undefined,
      createdAt: Date.now()
    };
    if (!nanoTimelineGeneratedAt) {
      setNanoTimelineGeneratedAt(userTimelineItem.createdAt);
    }
    setNanoTimelineItems((prev) => [...prev, userTimelineItem]);
    setNanoInputImages([]);
    setBase64("");

    try {
      const geminiModelName = generationModelType === "nano-banana-pro"
        ? GEMINI_PRO_IMAGE_MODEL
        : GEMINI_FLASH_IMAGE_MODEL;

      const response = await postAsync<any>("Generation/GenerateGeminiImage", {
        timelineId: nanoTimelineId,
        modelName: geminiModelName,
        aspectRatio: nanoTimelineId ? nanoTimelineAspectRatio : aspectRatio,
        imageSize: nanoTimelineId ? nanoTimelineImageSize : imageSize,
        text: normalizedText || undefined,
        imageBase64List: normalizedImages.length > 0 ? normalizedImages : undefined,
        imageBase64: normalizedImages.length > 0 ? normalizedImages[0] : undefined
      });

      const geminiResponse = response as unknown as GeminiGenerateApiResponse;
      const responseCode = geminiResponse.code ?? response.code;
      const responseMessage = geminiResponse.message ?? response.message;
      const responseTimelineId = geminiResponse.timelineId ?? geminiResponse.TimelineId;
      const responseAspectRatio = geminiResponse.aspectRatio ?? geminiResponse.AspectRatio;
      const responseImageSize = geminiResponse.imageSize ?? geminiResponse.ImageSize;
      const responseText = geminiResponse.text ?? geminiResponse.Text;
      const responseImageBase64 = geminiResponse.imageBase64 ?? geminiResponse.ImageBase64;
      const responseImageMimeType = geminiResponse.imageMimeType ?? geminiResponse.ImageMimeType;

      if (responseCode !== 1) {
        if (responseCode === -2) {
          toast.error("クレジットを使い切りました。");
          if (!subscription?.internalProductId?.startsWith('standard')) {
            setSubscriptionDialogProps({
              planId: getNextPlanId(subscription),
              isTrial: true
            } as SubscriptionDialogProps);
            openSubscriptionDialog();
          }
        }
        setNanoTimelineItems((prev) => [...prev, {
          role: "system",
          text: responseMessage ?? "生成に失敗しました。",
          createdAt: Date.now()
        }]);
        return;
      }

      if (responseTimelineId) {
        setNanoTimelineId(responseTimelineId);
      }
      if (responseAspectRatio) {
        setNanoTimelineAspectRatio(responseAspectRatio);
      }
      if (responseImageSize) {
        setNanoTimelineImageSize(responseImageSize);
      }

      const modelImageDataUrl = responseImageBase64 && responseImageMimeType
        ? `data:${responseImageMimeType};base64,${responseImageBase64}`
        : undefined;

      setNanoTimelineItems((prev) => [...prev, {
        role: "model",
        text: responseText || "生成が完了しました。",
        imageDataUrl: modelImageDataUrl,
        createdAt: Date.now()
      }]);
      fetchGeminiTimelineList();
    } catch (error: any) {
      setNanoTimelineItems((prev) => [...prev, {
        role: "system",
        text: error?.message ?? "生成に失敗しました。",
        createdAt: Date.now()
      }]);
    } finally {
      setNanoGenerating(false);
      setProcessing(false);
    }
  }

  async function onClickNanoFollowupSend() {
    const text = nanoFollowupText.trim();
    if (text === "" && nanoInputImages.length === 0) {
      return;
    }
    setNanoFollowupText("");
    await sendNanoTimelineMessage(text || undefined, nanoInputImages);
  }

  function resizeNanoFollowupTextarea(target?: HTMLTextAreaElement | null) {
    const textarea = target ?? nanoFollowupTextareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(textarea.scrollHeight, 160)}px`;
  }

  async function openNanoTimelineFromHistory(item: GeminiTimelineSummary) {
    try {
      const response = await fetchAsync<GeminiTimelineDetailApiResponse>('Generation/GetGeminiTimelineDetail', {
        timelineId: item.timelineId,
        includeImageBase64: false
      });

      const responseCode = response?.code ?? response?.Code;
      const responseMessage = response?.message ?? response?.Message;
      const responseTimelineId = response?.timelineId ?? response?.TimelineId;
      const responseModelName = response?.modelName ?? response?.ModelName ?? item.modelName;
      const responseAspectRatio = response?.aspectRatio ?? response?.AspectRatio ?? item.aspectRatio ?? "1:1";
      const responseImageSize = response?.imageSize ?? response?.ImageSize ?? item.imageSize;
      const responseMessages = response?.messages ?? response?.Messages ?? [];

      if (responseCode !== 1 || !responseTimelineId) {
        toast.error(responseMessage ?? "タイムラインの取得に失敗しました。");
        return;
      }

      const modelName = responseModelName;
      if (modelName === GEMINI_PRO_IMAGE_MODEL) {
        setGenerationModelType("nano-banana-pro");
      } else {
        setGenerationModelType("nano-banana");
      }

      const restoredItems: GeminiTimelineItem[] = (responseMessages ?? []).map((msg) => {
        const role = msg.role ?? msg.Role ?? "model";
        const text = msg.text ?? msg.Text;
        const imageBase64 = msg.imageBase64 ?? msg.ImageBase64;
        const imageMimeType = msg.imageMimeType ?? msg.ImageMimeType;
        const imageList = msg.images ?? msg.Images ?? [];
        const normalizedImageDataUrls = imageList
          .map((img) => {
            const b64 = img.imageBase64 ?? img.ImageBase64;
            const mime = img.imageMimeType ?? img.ImageMimeType;
            if (b64 && mime) return `data:${mime};base64,${b64}`;
            const imagePath = img.imagePath ?? img.ImagePath;
            const imageSrc = resolveImagePathToSrc(imagePath);
            if (imageSrc) return imageSrc;
            return "";
          })
          .filter((e) => e !== "");
        const createdDate = msg.createdDate ?? msg.CreatedDate;
        const singleImageDataUrl = imageBase64 && imageMimeType
          ? `data:${imageMimeType};base64,${imageBase64}`
          : undefined;
        const imageDataUrls = normalizedImageDataUrls.length > 0
          ? normalizedImageDataUrls
          : (singleImageDataUrl ? [singleImageDataUrl] : undefined);
        return {
          role,
          text,
          imageDataUrl: imageDataUrls?.[0],
          imageDataUrls,
          createdAt: createdDate ? new Date(createdDate).getTime() : Date.now()
        };
      });

      setNanoTimelineId(responseTimelineId);
      setNanoTimelineAspectRatio(responseAspectRatio);
      if (responseModelName === GEMINI_PRO_IMAGE_MODEL) {
        setNanoTimelineImageSize(responseImageSize ?? "1K");
      } else {
        setNanoTimelineImageSize("1K");
      }
      setNanoTimelineItems(restoredItems);
      if (restoredItems.length > 0) {
        const firstTs = restoredItems
          .map((e) => e.createdAt)
          .sort((a, b) => a - b)[0];
        setNanoTimelineGeneratedAt(firstTs);
      } else {
        setNanoTimelineGeneratedAt(undefined);
      }
      setProcessingMode("nano-banana");
      setProcessingDialogTab("timeline");
      openProcessingDialogWithHeader();
    } catch {
      toast.error("タイムラインの取得に失敗しました。");
    }
  }

  async function buildStandardImage() {
    if(selectedModel.length === 0) {
      toast.error("モデルのテイストを選んでください");
      return;
    }

    if(selectedHint.length === 0 && currentPrompt === '' && additionalPrompt === '') {
      toast.error("プロンプトを選んでください");
      return;
    }

    var startedCount = requestList.filter((e) => e.status === 'started').length;
    if(startedCount && startedCount >= 1) {
      toast.error("現在画像生成中です。");
      return;
    }
    
    if(processing) {
      return;
    }

    if(isLoggedIn === false) {
      openLoginDialog();
      return;
    }

    setGenerationRequest(undefined);
    setProcessing(true);
    setProcessingMode("standard");
    setProcessingDialogTab("basic");
    setThisPromptButtonVisible(false);
    
    var uids = selectedHint.map(e => e.uid);
    selectedItems.current = [];
    
    const normalizedBase64 = base64 === ''
      ? ''
      : (await convertImageSourceToDataUrl(base64)) ?? '';
    if (base64 !== '' && normalizedBase64 === '') {
      toast.error("参照画像の読み込みに失敗しました。画像を再選択してください。");
      setProcessing(false);
      return;
    }

    var param = {
      prompt: currentPrompt,
      negativePrompt: currentNegativePrompt,
      aspectRatio: aspectRatio,
      bulkCount: bulkCount,
      seed: seed,
      outputFormat: fileFomat,
      selectedHintUidList: uids,
      additionalPrompt: additionalPrompt,
      additionalNegativePrompt: additionalNegativePrompt,
      modelTasteUid: selectedModel[0].uid,
      guidanceScale: scale.toString(),
      inferenceSteps: stepCount.toString(),
      isImg2img: normalizedBase64 === '' ? false : true,
      originalImageBase64: normalizedBase64,
      strength: strength.toString(),
      resizeMode: resizeMode
    };

    
    const response = await postAsync<string>("Generation/Generate", param);
    

    if (response.code === -2) {
      if(subscription?.internalProductId.startsWith('standard')) {
        toast.error("クレジットを使い切りました。");
      } else{
        toast.error("クレジットを使い切りました。");
        setSubscriptionDialogProps({
          planId: getNextPlanId(subscription),
          isTrial: true
        } as SubscriptionDialogProps);
        openSubscriptionDialog(); 
      }
    }

    if(response.code === 1) {
      if(bulkCount == 1) {
        await fetchGeneratedList();
        openProcessingDialogWithHeader();
      } else {
        openProcessingMultiDialog();
      }
    }
    
    fetchGeneratedList();
    setProcessing(false);
    
    fetchRemainCount();
  }

  async function buildImage() {
    if (generationModelType === "nano-banana" || generationModelType === "nano-banana-pro") {
      await buildNanoBananaImage();
      return;
    }

    await buildStandardImage();
  }

  const fileFormatList = ['jpeg', 'png'];
  const nanoProImageSizeList = ['1K', '2K', '4K'];
  const resizeModeList = [
    {
      label: 'Resize and fill（推奨）',
      value: 'ResizeAndFill'
    },
    {
      label: 'Just resize',
      value: 'JustResize'
    },
    {
      label: 'Just resize latent upscaler',
      value: 'LatentUpscale'
    },
    {
      label: 'Crop and resize',
      value: 'CropAndResize'
    }
  ];

  function onClickThisPrompt(request: GenerationRequest){
    setSelectedHint([]);
    setAdditionalPrompt(request.prompt + ' ' + request.additionalPrompt);
    setAdditionalNegativePrompt(request.negativePrompt + ' ' + request.additionalNegativePrompt);
    closeProcessingDialogWithHeader();
  }

  async function onLoginEvent() {
     setIsLoggedIn(true);
     closeLoginDialog();
     fetchGeneratedList();
     fetchGeminiTimelineList();
     fetchActiveSubscription();
     fetchRemainCount();
  }

  function setClipboard(text: string | undefined){
    navigator.clipboard.writeText(text ?? '');
    toast.success("クリップボードにコピーしました");
  }

  function setWordsClipboard(text1: string | undefined, text2: string | undefined){
    navigator.clipboard.writeText(`${text1 ?? ''} ${text2 ?? ''}`);
    toast.success("クリップボードにコピーしました");
  }


  function buildDetailDialog(){
    if(selectedLargeCategory === '') {
      return <></>;
    }

    var selectedMiddleCategories = middleCategories.filter((e) => e.largeCategory === selectedLargeCategory);
    const selectedHintList = selectedLargeCategory === 'ネガティブプロンプト' ? negativeHintList : hintList;

    return <>
      <div id="login-dialog" className="dialog-overlay">
        <div className='dialog text-start max-h-[80vh] overflow-scroll' style={{ width: "unset", paddingTop: '0px' }}>
          <div className="pb-10 pt-4 bg-white" style={{ position: 'sticky', top: '0px'}}>
            <div className="mb-2 text-lg flex justify-between absolute w-full">
              <span>{ selectedLargeCategory }</span>
              <img onClick={(e) => setSelectedLargeCategory('')} src="/images/icon-close.svg" className="clickable w-[32px]"></img>
            </div>
          </div>
          { selectedMiddleCategories.map((middle) => (
            <div className="mb-4">
              <div className="mb-1">{middle.middleCategory}</div>
              <div>
              { selectedHintList.filter((e) => e.largeCategory === selectedLargeCategory && e.middleCategory === middle.middleCategory).map((small) => (
                buildHintSpan(small, false)
              ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>;
  }

  function getGenerationModelLabel(type: GenerationModelType) {
    if (type === "nano-banana-pro") return "Nano Banana Pro";
    if (type === "nano-banana") return "Nano Banana";
    return "Stable Diffusion XL";
  }

  function buildModelSelector(isMobile: boolean) {
    const label = getGenerationModelLabel(generationModelType);
    const modelIconSrc = generationModelType === "standard" ? "/images/stable-diffusion.png" : bananaIcon;
    const modelIconAlt = generationModelType === "standard" ? "stable diffusion" : "banana";
    const buttonClass = isMobile
      ? "h-6 max-w-[170px] min-w-0 px-1.5 rounded-xl border border-[#D9DCEF] bg-white inline-flex items-center justify-between text-[#11175B] font-bold text-[9px]"
      : "h-10 min-w-[240px] px-3 rounded-2xl border border-[#D9DCEF] bg-white inline-flex items-center justify-between text-[#11175B] font-bold text-sm";
    const iconStyle = isMobile ? { width: "10px", height: "10px" } : { width: "20px", height: "20px" };

    return (
      <button
        type="button"
        onClick={() => setModelSelectorOpened(true)}
        className={buttonClass}
      >
        <span className="inline-flex items-center gap-1 min-w-0 ml-0.5">
          <img
            src={modelIconSrc}
            alt={modelIconAlt}
            className="shrink-0 object-contain"
            style={iconStyle}
          />
          <span className="whitespace-nowrap truncate max-w-[132px]">{label}</span>
        </span>
        <span className="ml-1 text-[#5B63A8] shrink-0 text-[11px]">{">"}</span>
      </button>
    );
  }

  function buildNanoTimelineDialog() {
    const isSp = window.innerWidth < 640;
    const dialogWidth = isSp ? "100%" : "min(960px, calc(100vw - 40px))";
    const modelLabel = generationModelType === "nano-banana-pro" ? "Nano Banana Pro" : "Nano Banana";
    const followupModelIconSrc = generationModelType === "standard" ? "/images/stable-diffusion.png" : bananaIcon;
    const followupModelIconAlt = generationModelType === "standard" ? "Stable Diffusion XL" : modelLabel;
    const generatedImages = nanoTimelineItems
      .filter((e) => e.role === "model")
      .flatMap((e) => {
        if (e.imageDataUrls && e.imageDataUrls.length > 0) return e.imageDataUrls;
        return e.imageDataUrl ? [e.imageDataUrl] : [];
      });
    const lastUserText = [...nanoTimelineItems]
      .reverse()
      .find((e) => e.role === "user" && e.text && e.text.trim() !== "")?.text;
    const formatDateTime = (value?: number) => {
      if (!value) return "-";
      const d = new Date(value);
      const yyyy = d.getFullYear();
      const mm = `${d.getMonth() + 1}`.padStart(2, "0");
      const dd = `${d.getDate()}`.padStart(2, "0");
      const hh = `${d.getHours()}`.padStart(2, "0");
      const mi = `${d.getMinutes()}`.padStart(2, "0");
      return `${yyyy}/${mm}/${dd} ${hh}:${mi}`;
    };
    const renderBasicInfoRow = (label: string, value?: string) => (
      <div className="mt-4 first:mt-0">
        <div className="text-sm font-bold text-[#050B5A]">{label}</div>
        <div className="mt-1 text-sm leading-[1.5] text-[#4E556E] whitespace-pre-wrap break-words">
          {value && value.trim() !== "" ? value : "-"}
        </div>
      </div>
    );

    return (
      <div
        className='text-start max-h-[80vh] overflow-y-auto overflow-x-hidden w-full sm:h-[80vh] sm:overflow-hidden sm:flex sm:flex-col'
        style={{
          paddingTop: '0px',
          width: dialogWidth,
          maxWidth: dialogWidth,
          boxSizing: 'border-box',
          minHeight: '520px'
        }}
      >
        <div className="border-b pb-2"></div>
        <div className="mt-3 sm:hidden">
          <div className="text-base font-bold text-[#1F2352] mb-2">生成した画像</div>
          <div className="flex flex-wrap -mx-1 items-start content-start">
            {generatedImages.map((src, index) => (
              <div key={`generated-image-${index}`} className="w-full px-1 mb-2">
                <div
                  className="w-full clickable"
                  style={{ position: "relative", borderRadius: "0.5rem", border: "1px solid #E2E5F3", overflow: "hidden" }}
                  onClick={() => setPreviewImageDataUrl(src)}
                >
                  <div style={{ width: "100%", paddingTop: "100%" }}></div>
                  <img
                    src={src}
                    alt={`生成画像 ${index + 1}`}
                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                  />
                </div>
              </div>
            ))}
            {nanoGenerating && (
              <div className="w-full px-1 mb-2">
                <div
                  className="w-full"
                  style={{ position: "relative", borderRadius: "0.5rem", border: "1px dashed #C7CCE4", background: "#F8F9FF", overflow: "hidden" }}
                >
                  <div style={{ width: "100%", paddingTop: "100%" }}></div>
                  <div className="flex flex-col items-center justify-center text-xs text-[#3D4677]" style={{ position: "absolute", inset: 0 }}>
                    <Loader type="dots" size="14px" />
                    <span className="mt-1">画像生成中</span>
                  </div>
                </div>
              </div>
            )}
            {generatedImages.length === 0 && !nanoGenerating && (
              <div className="w-full px-1 text-xs text-[#8A90A7] py-2">まだ画像は生成されていません</div>
            )}
          </div>
        </div>
        <div className="mt-3 sm:grid sm:grid-cols-2 sm:gap-4 sm:items-stretch sm:flex-1 sm:min-h-0">
          <div className="hidden sm:flex sm:flex-col min-h-0">
            <div className="text-base font-bold text-[#1F2352] mb-2">生成した画像</div>
            <div className="flex flex-wrap -mx-1 items-start content-start flex-1 min-h-0 overflow-y-auto pr-1">
              {generatedImages.map((src, index) => (
                <div key={`generated-image-pc-${index}`} className="w-1/2 px-1 mb-2">
                  <div
                    className="w-full clickable"
                    style={{ position: "relative", borderRadius: "0.5rem", border: "1px solid #E2E5F3", overflow: "hidden" }}
                    onClick={() => setPreviewImageDataUrl(src)}
                  >
                    <div style={{ width: "100%", paddingTop: "100%" }}></div>
                    <img
                      src={src}
                      alt={`生成画像 ${index + 1}`}
                      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    />
                  </div>
                </div>
              ))}
              {nanoGenerating && (
                <div className="w-1/2 px-1 mb-2">
                  <div
                    className="w-full"
                    style={{ position: "relative", borderRadius: "0.5rem", border: "1px dashed #C7CCE4", background: "#F8F9FF", overflow: "hidden" }}
                  >
                    <div style={{ width: "100%", paddingTop: "100%" }}></div>
                    <div className="flex flex-col items-center justify-center text-xs text-[#3D4677]" style={{ position: "absolute", inset: 0 }}>
                      <Loader type="dots" size="14px" />
                      <span className="mt-1">画像生成中</span>
                    </div>
                  </div>
                </div>
              )}
              {generatedImages.length === 0 && !nanoGenerating && (
                <div className="w-full px-1 text-xs text-[#8A90A7] py-2">まだ画像は生成されていません</div>
              )}
            </div>
          </div>
          <div className="min-h-0 sm:h-full sm:flex sm:flex-col">
            <div className="mt-0 sm:mt-0 flex justify-center">
              <div className="inline-flex rounded-lg bg-[#F1F3FF] p-1 gap-1">
                <button
                  className={`px-4 py-1 text-sm rounded-md ${processingDialogTab === "basic" ? "bg-white text-[#0909FF]" : "text-[#5C5C7A]"}`}
                  onClick={() => setProcessingDialogTab("basic")}
                >
                  基本情報
                </button>
                <button
                  className={`px-4 py-1 text-sm rounded-md ${processingDialogTab === "timeline" ? "bg-white text-[#0909FF]" : "text-[#5C5C7A]"}`}
                  onClick={() => setProcessingDialogTab("timeline")}
                >
                  タイムライン
                </button>
              </div>
            </div>
            {processingDialogTab === "basic" &&
              <div className="mt-8 px-3 sm:px-4 sm:flex-1 sm:min-h-0 sm:overflow-y-auto">
                {renderBasicInfoRow("生成日時", formatDateTime(nanoTimelineGeneratedAt))}
                {renderBasicInfoRow("生成モデル", modelLabel)}
                {renderBasicInfoRow("アスペクト比", nanoTimelineAspectRatio)}
                {generationModelType === "nano-banana-pro" && renderBasicInfoRow("画像サイズ", nanoTimelineImageSize)}
                {renderBasicInfoRow("プロンプト", lastUserText)}
              </div>
            }
            {processingDialogTab === "timeline" &&
              <div className="mt-4 space-y-3 sm:flex-1 sm:min-h-0 sm:overflow-y-auto sm:pr-1">
                {nanoTimelineItems.map((item, index) => {
                  const isUser = item.role === "user";
                  const isSystem = item.role === "system";
                  const containerClass = isSystem
                    ? "bg-[#FFF7F7] border-[#FFD6D6]"
                    : isUser
                      ? "bg-[#EEF2FF] border-[#D9E2FF]"
                      : "bg-[#F8F6FF] border-[#E4DCF8]";
                  const rowClass = isSystem
                    ? "flex justify-center"
                    : isUser
                      ? "flex justify-end"
                      : "flex justify-start";
                  const widthClass = isSystem ? "w-full" : "w-[85%] sm:w-[80%]";
                  const itemImages = item.imageDataUrls && item.imageDataUrls.length > 0
                    ? item.imageDataUrls
                    : (item.imageDataUrl ? [item.imageDataUrl] : []);

                  return (
                    <div key={`timeline-item-${index}`} className={rowClass}>
                      <div className={`rounded-xl p-3 border ${containerClass} ${widthClass}`}>
                        {item.text && <div className="text-sm whitespace-pre-wrap text-[#1F2352]">{item.text}</div>}
                        {itemImages.length > 0 && (
                          <div className={`mt-2 grid ${itemImages.length === 1 ? "grid-cols-1" : "grid-cols-2"} gap-2`}>
                            {itemImages.map((src, imageIndex) => (
                              <img
                                key={`timeline-item-${index}-image-${imageIndex}`}
                                src={src}
                                className="w-full rounded-lg border border-[#E2E5F3] clickable"
                                onClick={() => setPreviewImageDataUrl(src)}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                {nanoGenerating &&
                  <div className="flex flex-col items-center justify-center gap-1 py-6">
                    <Loader type="dots" />
                    <span className="text-sm text-[#1F2352]">画像生成中</span>
                  </div>
                }
              </div>
            }
            {processingDialogTab === "timeline" &&
              <div className="mt-4 pt-3 border-t border-[#E6E8F0]">
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => ensureImg2ImgAgreedThenPick()}
                    disabled={nanoGenerating}
                    className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable relative overflow-hidden shrink-0 self-center disabled:opacity-50"
                    title="画像を追加"
                  >
                    <img src={iconImageAdd} alt="画像追加" className="w-4 h-4" />
                  </button>
                  <div className="hidden sm:block">
                    {buildSelectedInputImageRow(true)}
                  </div>
                  <div className="flex-1 relative mt-[2px]">
                    <img
                      src={followupModelIconSrc}
                      alt={followupModelIconAlt}
                      className="w-5 h-5 object-contain absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
                    />
                    <textarea
                      ref={nanoFollowupTextareaRef}
                      value={nanoFollowupText}
                      onChange={(e) => setNanoFollowupText(e.target.value)}
                      onInput={(e) => resizeNanoFollowupTextarea(e.currentTarget)}
                      onKeyDown={async (e) => {
                        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && !e.nativeEvent.isComposing) {
                          e.preventDefault();
                          await onClickNanoFollowupSend();
                        }
                      }}
                      disabled={nanoGenerating}
                      placeholder="追加で指示を入力"
                      rows={1}
                      className="w-full mt-2 border border-[#CDD3EA] rounded-lg pl-10 pr-3 py-2 text-sm outline-none focus:border-[#8A92F8] resize-none leading-5 min-h-[40px] max-h-[160px] overflow-y-auto"
                    />
                  </div>
                  <div className="h-10 flex items-center text-[14px] leading-none pr-[2px] shrink-0" style={{ fontWeight: 400 }}>
                    <img src="/images/icon/icons8-lightning.png" alt="消費クレジット" className="w-[14px] h-[14px] mr-[2px]" />
                    <span>{currentGenerationCreditCost ?? "-"}</span>
                  </div>
                  <button
                    type="button"
                    onClick={onClickNanoFollowupSend}
                    disabled={nanoGenerating || (nanoFollowupText.trim() === "" && selectedInputImageCount === 0)}
                    className="w-10 h-10 rounded-lg text-sm text-white disabled:opacity-50 flex items-center justify-center shrink-0"
                    style={{ background: "linear-gradient(91.51deg, #0000F3 0.07%, #F416BF 100.07%)" }}
                  >
                    <img src="/images/flare.png" alt="生成" className="w-5 h-5" />
                  </button>
                </div>
                <div className="sm:hidden">
                  {buildSelectedInputImageRow()}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  function buildProcessingDialog(){
    if (processingMode === "nano-banana") {
      return <>
        <Modal zIndex={300} size="auto" opened={processingDialogOpened} onClose={closeProcessingDialogWithHeader}>
          {buildNanoTimelineDialog()}
        </Modal>
      </>;
    }

    let request = generationRequest;
    return <>
    <Helmet>
      <title>画像生成 - Drop AI</title>
      <meta name="description" content="お気に入りのモデルとプロンプトを選ぶだけ！高品質なAI画像を生成しよう。" />
      <meta property="og:url" content="https://drop4i.com/image-generation" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="画像生成 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="お気に入りのモデルとプロンプトを選ぶだけ！高品質なAI画像を生成しよう。" />
    </Helmet>
    <Modal zIndex={300} size="auto" opened={processingDialogOpened} onClose={closeProcessingDialogWithHeader}>
      <div className='text-start max-h-[80vh] overflow-scroll w-full sm:w-[1080px]' style={{ paddingTop: '0px' }}>
        <div className="block sm:flex">
          <div className="w-full sm:w-[50%] items-center sm:min-h-[500px] justify-center">
            <div className="min-w-[100%] px-1 my-1">
              { (remainCount === undefined || request?.status === 'started') &&
                <div key={request?.uid} className="text-center min-h-[250px] sm:min-h-[450px] align-middle justify-center flex items-center" style={{ marginTop: "auto"}}>
                  <div className="flex flex-col items-center h-full">
                    <Loader type="dots" />
                  <span className="text-sm mt-2">画像生成中</span>
                  </div>
                </div>
              }
              { ( request !== undefined && request.status === 'complete' ) &&
                <>
                { request!.isNsfw === 1 &&
                  <div key={request.uid} className="w-[100%] min-w-[95px] h-[100%] min-h-[240px] sm:min-h-[480px] p-1bg-black text-white text-center flex items-center justify-center px-6 bg-black text-xs">
                    不適切な画像を生成した可能性がございます
                  </div>
                }
                { request!.isNsfw === 0 &&
                <div key={request.uid} className="relative">
                  <img style={{ width: '100%' }} src={`${process.env.REACT_APP_IMAGE_URL}/${request.requestId}`} />
                  <button
                    type="button"
                    onClick={() => {
                      onSetBase64(`${process.env.REACT_APP_IMAGE_URL}/${request!.requestId}`);
                      closeProcessingDialogWithHeader();
                    }}
                    className="absolute right-3 bottom-3 w-11 h-11 rounded-full bg-white/95 border border-[#D7DCEF] shadow-md flex items-center justify-center clickable"
                    title="参照画像として使う"
                  >
                    <img src={iconImageAdd} alt="参照画像として使う" className="w-5 h-5 object-contain" />
                  </button>
                </div>
                }
                </>
              }
              { ( request !== undefined && request.status === 'error' ) &&
                <div key={request.uid} className="w-[100%] min-w-[95px] h-[100%] min-h-[240px] sm:min-h-[480px] p-1bg-black text-white text-center flex items-center justify-center px-4 bg-black">
                  画像生成エラーが発生しました。時間をおいてリトライしてください。<br />
                  何度トライしてもエラーが解消されない場合、大変お手数ですがコンタクトページよりお問い合わせをくださいませ。<br />
                </div>
              }
            </div>
          </div>
          <div className="w-full sm:w-[50%] ml-0 sm:ml-4 mt-4 sm:mt-0">
            <div className="text-sm font-bold">生成AIモデル</div>
            <div className="text-sm py-1 rounded">
              Stable Diffusion XL
            </div>
            <div className="text-sm mt-4 font-bold">モデルテイスト</div>
            <div className="text-sm py-1 rounded">
              { request?.tasteName }
            </div>
            <div className="text-sm mr-4 mt-4 font-bold">プロンプト</div>
            <div className="text-sm py-1 px-2 min-h-7 rounded flex justify-between bg-gray-100">
              { `${request?.prompt} ${request?.additionalPrompt}` }
              <img onClick={(e) => setWordsClipboard(request?.prompt, request?.additionalPrompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-4 font-bold">ネガティブプロンプト</div>
            <div className="text-sm py-1 px-2 min-h-7 rounded flex justify-between bg-gray-100">
              <span className="mr-1">{ `${request?.negativePrompt} ${request?.additionalNegativePrompt}` }</span>
              <img onClick={(e) => setWordsClipboard(request?.negativePrompt, request?.additionalNegativePrompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-4 font-bold">画像アスペクト比</div>
            <div className="text-sm py-1 px-2 rounded">
              { `${request?.aspectRatio} (${request?.width}px x ${request?.height}px)` }
            </div>
            <div className="text-sm mt-4 font-bold">ステップ数</div>
            <div className="text-sm py-1 rounded">
              { request?.inferenceSteps }
            </div>
            <div className="text-sm mt-2 font-bold">シード値</div>
            <div className="text-sm py-1 px-2 rounded flex justify-between bg-gray-100">
              <span>{ request?.seed }</span>
              <img onClick={(e) => setClipboard(request?.seed?.toString())} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-2 font-bold">スケール</div>
            <div className="text-sm py-1 rounded">
              { request?.guidanceScale }
            </div>
            { request?.isImg2Img === true &&
            <>
            <div className="text-sm mt-2 font-bold">img2img ノイズ除去の強度</div>
            <div className="text-sm py-1 rounded">
                { request?.strength }
              </div>
            </>
            }
            <div className="mt-6">
              { thisPromptButtonVisible &&
                <button className="w-full gradation-button py-2 px-12 rounded font-bold clickable" onClick={(e) => onClickThisPrompt(request!)}>このプロンプトを利用する</button>
              }
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </>;
  }

  function onSelectGenerationImage(request: GenerationRequest){
    setGenerationRequest(request);
    setProcessingMode("standard");
    setProcessingDialogTab("basic");
    openProcessingDialogWithHeader();
  }

  function buildMultiProcessingDialog(){
    if(requestList.length == 0) {
      return <></>;
    }

    let screenWidth = window.innerWidth;
    let list = requestList.slice(0, bulkCount).reverse();
    var height = bulkCount == 4 ? 500 : 200;
    var width = bulkCount == 4 ? 600 : 800;

    if(screenWidth <= 640) {
      var height = bulkCount == 4 ? 150 : 100;
      var width = bulkCount == 4 ? 300 : 300;
    }

    var imageWidth = (width / 2);
    var imageHeight = bulkCount == 4 ? 300 : height;
    
    return <>
    <Modal size="auto" opened={processingMultiDialogOpened} onClose={closeProcessingMultiDialog}>
      <div className='max-h-[80vh] overflow-scroll' style={{ width: `${width}px`, paddingTop: '0px' }}>
        <div className="">
          <div className={`block sm:flex items-center min-h-[${height}px] inline-flex flex-wrap justify-around`}>
          { list.map((item) => (
            <div className="px-1 my-1" style={{ width: `${imageWidth}px` }}>
              { item.status === 'started' &&
                <div key={item.uid} className={`text-center align-middle justify-center flex items-center`} style={{ marginTop: "auto", minHeight: `${imageHeight}px` }}>
                  <div className="flex flex-col items-center h-full">
                    <Loader type="dots" />
                    <span className="text-sm mt-2">画像生成中</span>
                  </div>
                </div>
              }
              { item.status === 'complete' &&
                <>
                { item.isNsfw === 1 &&
                  <div key={item.uid} style={{ height: `${imageHeight}px`, width: `${imageWidth}px` }} className="bg-black text-white text-center flex items-center justify-center bg-black text-xs px-4">
                    不適切な画像を生成した可能性がございます
                  </div>
                }
                { item.isNsfw === 0 &&
                <div onClick={(e) => onSelectGenerationImage(item)}  key={item.uid} className="clickable">
                  <img style={{ width: `${imageWidth}px` }} src={`${process.env.REACT_APP_IMAGE_URL}/${item.requestId}`} />
                  </div>
                }
                </>
              }
              { item.status === 'error' &&
                <div key={item.uid} style={{ height: `${imageHeight}px`, width: `${imageWidth}px` }} className="bg-black text-white text-center flex items-center justify-center bg-black">
                  エラーが発生しました
                </div>
              }
            </div>    
          ))}
          </div>
        </div>
      </div>
    </Modal>
  </>;
  }

  function toggleModelTaste(hint: ModelTaste) {
    let newList = [hint];
    setSelectedModel(newList);
  }

  function toggleSelect(hint: FlatPromptHint) {
    let newList = [...selectedHint];
    hint.isFocused = false;
    var hasHint = selectedHint.filter((e) => e.uid == hint.uid).length >= 1;
    if(hasHint) {
      newList = newList.filter((e) => e.uid !== hint.uid);
    } else {
      newList.push(hint);
    }
    setSelectedHint(newList);

    var selectedPrompt = newList.filter((e) => e.prompt !== '').map(e => e.isFocused ? `((${e.prompt}))` : e.prompt).join(",");
    var selectedNegativePrompt = newList.filter((e) => e.negativePrompt !== '').map(e => e.isFocused ? `((${e.negativePrompt}))` : e.negativePrompt).join(",");
    setCurrentPrompt(selectedPrompt);
    setCurrentNegativePrompt(selectedNegativePrompt);
  }

  function buildHintSpan(item: FlatPromptHint, isNegative: boolean) {
    const isSelected = selectedHint.filter((e) => e.uid === item.uid).length >= 1;
    var color = "#03034F";
    var borderColor = isSelected ? "#0909FF" : "#CED4DA";
    var bgColor = isSelected ? "#CFCFFF" : "#fff";

    if(isNegative && isSelected) {
      borderColor = "#F416BF";
      bgColor = "#FFD0F4";
    }

    var svgPath = "";
    if(isNegative) {
      svgPath = isSelected ? "/images/icon/icon-minus-red.svg" : "/images/icon/icon-minus-grey.svg";
    } else {
      svgPath = isSelected ? "/images/icon/icon-plus-blue.svg" : "/images/icon/icon-plus-grey.svg";
    }

    return <span onClick={(e) => toggleSelect(item)} className="clickable border rounded-xl mr-2 px-2 py-1 whitespace-nowrap" style={{ lineHeight: '36px', borderColor: borderColor, color: color, backgroundColor: bgColor }}>
      <span className="mr-1 clickable items-center inline-flex" style={{ color: borderColor}}>
        <img src={svgPath} className="w-[12px] h-[12px] inline"></img>
      </span>
      {item.name}
      </span>;
  }

  function buildSelectedSpan(item: FlatPromptHint, isNegative: boolean) {
    var borderColor = item.isFocused ? "#0909FF" : "#0909FF";
    var bgColor = item.isFocused ? "#CFCFFF" : "#EAEAFF";
    
    if(isNegative) {
      borderColor = "#F416BF";
      bgColor = "#FFD0F4";
      if(item.isFocused) {
        bgColor = "#FFD0F4";
      }
    }

    var svgPath = isNegative ? "/images/icon/icon-minus-red.svg" : "/images/icon/icon-plus-blue.svg";
    var upArrowPath =  isNegative ? "/images/icon/up-arrow-red.svg" : "/images/icon/up-arrow-blue.svg";

    return <>
    <span className="mb-2 border rounded-xl mr-1 pl-2 pr-2 py-0.5 whitespace-nowrap inline-flex w-auto items-center text-primary" style={{ borderColor: borderColor, backgroundColor: bgColor }}>
      <span className="mr-1 text-[#0909FF] clickable" onClick={(e) => toggleFocus(item)}>
        <img src={svgPath} className="w-[12px] h-[12px] inline"></img>
      </span>
      { item.isFocused  &&
      <img onClick={(e) => toggleFocus(item)} src={upArrowPath} className="h-[14px] clickable mr-1"></img>
      }
      <span className="text-sm" onClick={(e) => toggleFocus(item)}>{item.name}</span>
      <img onClick={(e) => toggleSelect(item)} src="/images/icon-close.svg" className="h-[14px] clickable ml-1 sm:pr-0 pr-2"></img>
    </span>
    </>;
  }

  function toggleFocus(item: FlatPromptHint) {
    let newList = [...selectedHint];
    var index = selectedHint.findIndex((e) => e.uid == item.uid);
    item.isFocused = !item.isFocused;
    
    newList[index] = item;
    setSelectedHint(newList);

    var selectedPrompt = newList.filter((e) => e.prompt !== '').map(e => e.isFocused ? `((${e.prompt}))` : e.prompt).join(",");
    setCurrentPrompt(selectedPrompt);

    var selectedNegativePrompt = newList.filter((e) => e.negativePrompt !== '').map(e => e.isFocused ? `((${e.negativePrompt}))` : e.negativePrompt).join(",");
    setCurrentNegativePrompt(selectedNegativePrompt);
  }

  function buildTasteImage(item: ModelTaste) {
    const isSelected = selectedModel.filter((e) => e.uid === item.uid).length >= 1;
    var borderStyle = isSelected ? "3px solid #0909FF" : "3px solid white";
    const opacity = isSelected ? 0.8 : 1;
    return <>
      <div key={`taste-${item.uid}`} onClick={(e) => toggleModelTaste(item)} className="relative mr-2 clickable rounded-md" style={{ border: borderStyle, opacity: opacity }}>
        <div className="w-full text-center absolute flex items-center h-[100%]">
          <span className="text-white w-[100%]" style={{ fontWeight: "900", fontSize: "15px", WebkitTextStrokeWidth: "0.2px", WebkitTextStrokeColor: "#000000", whiteSpace: "break-spaces" }}>{item.name}</span>
        </div>
        <img src={`/images/taste/${item.sampleImageFile}`} className="min-w-[120px] min-h-[120px] w-[120px] h-[120px] rounded" style={{ objectFit: "cover" }}></img>
      </div>
    </>;
  }

  async function onSelectInspiration(inspiration: Inspiration){
    setInspiration(inspiration);
    openInspirationDialog();
  }

  function sleep(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function buildSearchOption(hint: FlatPromptHint){
    return <>
      <div onClick={(e) => onSelectSearchOption(hint)} className="py-1 px-1 min-w-[200px] text-gray-600 clickable">
        {hint.name}
      </div>
    </>;
  }

  function clearSettings(){
    setSelectedModel([]);
    setSelectedHint([]);
    setCurrentPrompt('');
    setCurrentNegativePrompt('');
    setAdditionalNegativePrompt('');
    setAdditionalPrompt('');
    setAspectRatio('1:1');
    setImageSize('1K');
  }

  function buildAspectRatioOption(ratio: AspectRatio){
    var width = 0;
    var height = 0;
    if(ratio.ratio === '1:1'){ width = 55; height = 55; }
    if(ratio.ratio === '2:1'){ width = 55; height = 27.5; }
    if(ratio.ratio === '3:2'){ width = 55; height = 36.67; }
    if(ratio.ratio === '2:3'){ width = 36.67; height = 55; }
    if(ratio.ratio === '9:16'){ width = 30.9375; height = 55; }
    if(ratio.ratio === '16:9'){ width = 55; height = 30.9375; }
    if(ratio.ratio === '21:9'){ width = 55; height = 23.57; }

    var isSelected = aspectRatio === ratio.ratio;    
    return <div className="text-sm py-1 text-center align-middle clickable justify-between">
        <div className="w-min mx-auto">
          <Radio color="#0909FF" key={`format-${ratio.ratio}`} value={ratio.ratio}></Radio>
        </div>
        <span onClick={(e) => setAspectRatio(ratio.ratio)} className="min-h-[60px] block mt-1">
          <label htmlFor={ratio.ratio} className="text-xs border rounded-md inline-flex items-center justify-center" style={{ width: `${width}px`, height: `${height}px`, borderColor: isSelected ? '#0909FF' : '', color: isSelected ? '#0909FF' : '', backgroundColor: isSelected ? '#EAEAFF' : '' }}>{ratio.ratio}</label>
        </span>
      </div>;

  }

  function onSelectSearchOption(hint: FlatPromptHint){
    toggleSelect(hint);
    setPromptSearchResult([]);
    setSeachText('');
    setNegativePromptSearchResult([]);
    setNegativeSearchText('');
  }

  function onChangeSearchText(text: string) {
    setSeachText(text);
    if (text == '') {
      setPromptSearchResult([]);
      return;
    }

    var list = hintList.filter((e) => e.name.includes(text)).slice(0, 10);
    setPromptSearchResult(list);
  }

  function onChangeNegativeSearchText(text: string) {
    setNegativeSearchText(text);
    if (text == '') {
      setNegativePromptSearchResult([]);
      return;
    }

    var list = negativeHintList.filter((e) => e.name.includes(text)).slice(0, 10);
    setNegativePromptSearchResult(list);
  }

  function buildInspirationDialog(){
    return <>
    <Modal size="auto" opened={inspirationDialogOpened} onClose={() => closeInspirationDialog()}>
      <InspirationDialog inspiration={inspiration} mainTasteList={mainTasteList} />
    </Modal>
    </>;
  }

  function onClickGeneratedImage(item: GenerationRequest){
    setThisPromptButtonVisible(true);
    setGenerationRequest(item);
    setProcessingMode("standard");
    setProcessingDialogTab("basic");
    openProcessingDialogWithHeader();
  }

  function buildUnifiedHistoryItems() {
    const standardItems = requestList.map((item) => ({
      type: "standard" as const,
      sortTs: item.createdDate ? new Date(item.createdDate).getTime() : 0,
      data: item
    }));

    type NanoHistoryItem = {
      type: "nano";
      sortTs: number;
      data: GeminiTimelineSummary;
      imagePath?: string;
      imageDataUrl?: string;
      imageIndex: number;
    };

    const nanoItems: NanoHistoryItem[] = nanoTimelineHistory
      .reduce<NanoHistoryItem[]>((acc, item) => {
        const imagePaths = (item.images ?? [])
          .map((img) => img.imagePath)
          .filter((path): path is string => !!path);
        if (imagePaths.length > 0) {
          imagePaths.forEach((imagePath, imageIndex) => {
            acc.push({
              type: "nano",
              sortTs: item.updatedDate ? new Date(item.updatedDate).getTime() : 0,
              data: item,
              imagePath,
              imageDataUrl: undefined,
              imageIndex
            });
          });
          return acc;
        }

        if (item.lastImagePath) {
          acc.push({
            type: "nano",
            sortTs: item.updatedDate ? new Date(item.updatedDate).getTime() : 0,
            data: item,
            imagePath: item.lastImagePath,
            imageDataUrl: undefined,
            imageIndex: 0
          });
          return acc;
        }

        if (item.lastImageBase64 && item.lastImageMimeType) {
          acc.push({
            type: "nano",
            sortTs: item.updatedDate ? new Date(item.updatedDate).getTime() : 0,
            data: item,
            imagePath: undefined,
            imageDataUrl: `data:${item.lastImageMimeType};base64,${item.lastImageBase64}`,
            imageIndex: 0
          });
          return acc;
        }

        acc.push({
          type: "nano",
          sortTs: item.updatedDate ? new Date(item.updatedDate).getTime() : 0,
          data: item,
          imagePath: undefined,
          imageDataUrl: undefined,
          imageIndex: 0
        });
        return acc;
      }, []);

    return [...standardItems, ...nanoItems]
      .sort((a, b) => b.sortTs - a.sortTs)
      .map((entry, index) => {
        if (entry.type === "standard") {
          const e = entry.data;
          if (e.status === 'started') {
            return (
              <div key={`history-standard-started-${e.requestId}-${index}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                <div className="flex w-full aspect-square border">
                  <div className="m-auto text-center w-full">
                    <Loader type="dots" className="mx-auto" size="20px" />
                    <span className="text-xs">生成中</span>
                  </div>
                </div>
              </div>
            );
          }

          if (e.status === 'complete') {
            return (
              <div key={`history-standard-complete-${e.requestId}-${index}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                { e.isNsfw === 1 ? (
                  <div onClick={() => onClickGeneratedImage(e)} className="w-full aspect-square rounded-lg bg-black text-white text-center flex items-center justify-center text-xs p-1 clickable">不適切な画像</div>
                ) : (
                  <img onClick={() => onClickGeneratedImage(e)} className="clickable w-full aspect-square object-cover rounded-lg" src={`${process.env.REACT_APP_IMAGE_URL}/${e.requestId}_mid`} />
                )}
              </div>
            );
          }

          if (e.status === 'error') {
            return (
              <div key={`history-standard-error-${e.requestId}-${index}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                <div onClick={() => onClickGeneratedImage(e)} className="w-full aspect-square rounded-lg bg-black text-white text-center flex items-center justify-center text-xs p-1 clickable">エラーが発生しました</div>
              </div>
            );
          }

          return null;
        }

        const e = entry.data;
        const imageSrc = resolveImagePathToSrc(entry.imagePath) ?? entry.imageDataUrl;
        if (!imageSrc) {
          return null;
        }

        return (
          <div key={`history-nano-${e.timelineId}-${entry.imageIndex}-${index}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
            <div onClick={() => openNanoTimelineFromHistory(e)} className="w-full aspect-square rounded-lg border border-[#D9DDF2] clickable relative overflow-hidden bg-[#F5F7FF]">
              <img className="w-full h-full object-cover" src={imageSrc} />
            </div>
          </div>
        );
      });
  }

  function clearPromptHint(){
    setSelectedHint(selectedHint.filter((e) => e.isNegativePrompt === true));
    setAdditionalPrompt('');
  }

  function clearNegativePromptHint(){
    setSelectedHint(selectedHint.filter((e) => e.isNegativePrompt === false));
    setAdditionalNegativePrompt('');
  }

  function onCloseSubscriptionDialog(){
    closeSubscriptionDialog();
    setProcessing(false);
  }

  function onCloseSkyFlagDialog(){
    closeSkyFlagDialog();
    setProcessing(false);
  }

  const clearAllPrompts = () => {
    setSelectedHint([]);
    setAdditionalPrompt('');
    setAdditionalNegativePrompt('');
    setMobileNegativeVisible(false);
  };

  const maybeOpenTranslationIntro = () => {
    if (translationIntroEverShown) return;
    setTranslationIntroEverShown(true);
    try {
      const seen = typeof window !== 'undefined' ? localStorage.getItem(TRANSLATION_INTRO_KEY) : '1';
      if (!seen) {
        localStorage.setItem(TRANSLATION_INTRO_KEY, '1');
        setTranslationIntroOpened(true);
      }
    } catch {
      setTranslationIntroOpened(true);
    }
  };

  const maybeOpenGenerateIntro = () => {
    if (generateIntroEverShown) return;
    setGenerateIntroEverShown(true);
    try {
      const seen = typeof window !== 'undefined' ? localStorage.getItem(GENERATE_INTRO_KEY) : '1';
      if (!seen) {
        localStorage.setItem(GENERATE_INTRO_KEY, '1');
        setGenerateIntroOpened(true);
      }
    } catch {
      setGenerateIntroOpened(true);
    }
  };

  async function translatePrompt(isPrompt: boolean) {
    maybeOpenTranslationIntro();
    if (isPrompt) {
      setIsPromptTranslating(true);
    } else {
      setIsNegativePromptTranslating(true);
    }
    try {
      const prompt = isPrompt ? additionalPrompt : additionalNegativePrompt;
      const param = { OriginalText: prompt, IsNegativePrompt: !isPrompt ? true : false };
      const response = await postAsync<string>('Translate/TranslateToJp', param);
      if (response?.data) {
        if (isPrompt) {
          setAdditionalPrompt(response.data);
        } else {
          setAdditionalNegativePrompt(response.data);
        }
      }
    } finally {
      if (isPrompt) {
        setIsPromptTranslating(false);
      } else {
        setIsNegativePromptTranslating(false);
      }
    }
  }

  const isImg2ImgAgreed = (acc?: any) => {
    const flag = acc?.isImg2imgAgreed ?? acc?.IsImg2imgAgreed;
    return flag === 1 || flag === true;
  };

  const ensureImg2ImgAgreedThenPick = async () => {
    if (!isLoggedIn) {
      openLoginDialog();
      return;
    }

    try {
      let agreed = isImg2ImgAgreed(account);
      if (!agreed) {
        try {
          await fetchAccount();
          const refreshed = useHeaderStore.getState().account;
          agreed = isImg2ImgAgreed(refreshed);
        } catch {}
      }

      if (agreed) {
        imageUploaderRef.current?.openFileDialog();
        return;
      }

      setImg2imgAgreeChecked(false);
      setImg2imgAgreeVisible(true);
    } catch {
      setImg2imgAgreeChecked(false);
      setImg2imgAgreeVisible(true);
    }
  };

  const onAgreeImg2Img = async () => {
    if (!isLoggedIn) {
      openLoginDialog();
      return;
    }

    try {
      setImg2imgAgreeLoading(true);
      await postAsync<any>('Account/AgreeImg2Img', {});
      try {
        await fetchAccount();
      } catch {}
      setImg2imgAgreeVisible(false);
      setTimeout(() => {
        imageUploaderRef.current?.openFileDialog();
      }, 200);
    } catch (e) {
      toast.error("同意処理に失敗しました。時間をおいて再度お試しください。");
    } finally {
      setImg2imgAgreeLoading(false);
    }
  };

  function onSetBase64(base64: string) {
    const isNanoModel = generationModelType === "nano-banana" || generationModelType === "nano-banana-pro";
    if (base64 === "") {
      setBase64("");
      setNanoInputImages([]);
      return;
    }

    setBase64(base64);
    if (isNanoModel) {
      setNanoInputImages((prev) => {
        if (prev.includes(base64)) return prev;
        const appended = [...prev, base64];
        return appended.length > 14 ? appended.slice(appended.length - 14) : appended;
      });
    } else {
      setNanoInputImages([base64]);
    }
  }

  function onClickUsePreviewImageAsReference() {
    if (!previewImageDataUrl) return;
    onSetBase64(previewImageDataUrl);
    setPreviewImageDataUrl(undefined);
  }

  function removeSelectedInputImage(index: number) {
    if (isNanoModelSelected) {
      setNanoInputImages((prev) => {
        if (index < 0 || index >= prev.length) return prev;
        const next = prev.filter((_, i) => i !== index);
        setBase64(next.length > 0 ? next[next.length - 1] : "");
        return next;
      });
      return;
    }

    setBase64("");
    setNanoInputImages([]);
  }

  function buildSelectedInputImageRow(isInline: boolean = false) {
    if (selectedInputImages.length === 0) return null;

    return (
      <div className={`${isInline ? "ml-1 max-w-[120px]" : "mt-2"} flex items-center gap-2 overflow-x-auto pb-1`}>
        {selectedInputImages.map((img, index) => (
          <div
            key={`selected-input-image-${index}`}
            className="relative shrink-0 w-8 h-8 rounded-lg overflow-hidden border border-[#D7DCEF] bg-white"
          >
            <img src={img} alt={`選択画像${index + 1}`} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                removeSelectedInputImage(index);
              }}
              className="absolute -top-1 -right-1 w-3.5 h-3.5 rounded-full bg-white border border-gray-300 flex items-center justify-center"
              aria-label="画像を削除"
            >
              <img src="/images/icon-close.svg" alt="削除" className="w-2 h-2" />
            </button>
          </div>
        ))}
      </div>
    );
  }

  const isNanoModelSelected = generationModelType === "nano-banana" || generationModelType === "nano-banana-pro";
  const isStandardGenerationModel = generationModelType === "standard";
  const currentPlanTier = resolvePlanTierFromInternalProductId(subscription?.internalProductId);
  const canSelectNanoBananaPro = currentPlanTier === "lite" || currentPlanTier === "standard" || currentPlanTier === "advanced";
  const allowedNanoProImageSizes = currentPlanTier === "advanced"
    ? ["1K", "2K", "4K"]
    : currentPlanTier === "lite" || currentPlanTier === "standard"
      ? ["1K", "2K"]
      : [];
  const aspectRatioOptionsForCurrentModel = isNanoModelSelected
    ? ratioList.filter((e) => NANO_GEMINI_ALLOWED_ASPECT_RATIOS.includes(e.ratio ?? ""))
    : ratioList;
  const selectedInputImages = isNanoModelSelected
    ? nanoInputImages
    : (base64 ? [base64] : []);
  const selectedInputImageCount = selectedInputImages.length;
  const isImagePreviewOpened = !!previewImageDataUrl;
  const currentGenerationCreditCost = (() => {
    if (generationModelType === "standard") {
      return getStandardConsumingPoint(currentPlanTier) * bulkCount;
    }
    if (generationModelType === "nano-banana") {
      return getNanoBananaConsumingPoint(currentPlanTier);
    }
    return getNanoBananaProConsumingPoint(currentPlanTier, imageSize);
  })();

  useEffect(() => {
    if (!isNanoModelSelected) return;
    if (NANO_GEMINI_ALLOWED_ASPECT_RATIOS.includes(aspectRatio)) return;

    const fallback = ratioList
      .find((e) => NANO_GEMINI_ALLOWED_ASPECT_RATIOS.includes(e.ratio ?? ""))
      ?.ratio ?? "1:1";
    setAspectRatio(fallback);
  }, [isNanoModelSelected, aspectRatio, ratioList]);

  useEffect(() => {
    if (!isNanoModelSelected) return;
    if (!mobileNegativeVisible) return;
    setMobileNegativeVisible(false);
  }, [isNanoModelSelected, mobileNegativeVisible]);

  useEffect(() => {
    if (generationModelType !== "nano-banana-pro") return;
    if (canSelectNanoBananaPro) return;
    setGenerationModelType("nano-banana");
  }, [generationModelType, canSelectNanoBananaPro]);

  useEffect(() => {
    if (generationModelType !== "nano-banana-pro") return;
    if (allowedNanoProImageSizes.length === 0) return;
    if (allowedNanoProImageSizes.includes(imageSize)) return;
    setImageSize(allowedNanoProImageSizes[0]);
  }, [generationModelType, imageSize, allowedNanoProImageSizes]);

  useEffect(() => {
    resizeNanoFollowupTextarea();
  }, [nanoFollowupText, processingDialogOpened, processingMode, processingDialogTab]);

  return <>
    { buildDetailDialog() }
    { buildMultiProcessingDialog()}
    { buildProcessingDialog() }
    { inspiration && buildInspirationDialog() }
    <Modal
      size="auto"
      zIndex={1000}
      opened={isImagePreviewOpened}
      onClose={() => setPreviewImageDataUrl(undefined)}
      centered
    >
      <div className="relative max-w-[90vw] max-h-[85vh]">
        {previewImageDataUrl && (
          <img
            src={previewImageDataUrl}
            alt="拡大画像"
            className="max-w-[90vw] max-h-[80vh] object-contain block"
          />
        )}
        <button
          type="button"
          onClick={onClickUsePreviewImageAsReference}
          className="absolute right-3 bottom-3 w-11 h-11 rounded-full bg-white/95 border border-[#D7DCEF] shadow-md flex items-center justify-center clickable"
          title="参照画像として使う"
        >
          <img src={iconImageAdd} alt="参照画像にセット" className="w-6 h-6" />
        </button>
      </div>
    </Modal>
    
    <Modal size="auto" opened={subscriptionDialogOpened} onClose={() => { closeSubscriptionDialog(); openSkyFlagDialog(); }} yOffset={getModalOffset(screenWidth)} >
      <SubscriptionDialog
        upgradeTextVisible={true}
        onPurchase={() => closeSubscriptionDialog()}
        onCancel={() => { closeSubscriptionDialog(); openSkyFlagDialog(); }}
        planId={subscriptionDialogProps?.planId} />
    </Modal>

    <Modal size="auto" opened={skyFlagRewardDialogOpened} onClose={closeSkyFlagRewardDialog} yOffset={getModalOffset(screenWidth)} >
      <SkyFlagRewardDialog />
    </Modal>

    <Modal size="auto" opened={skyFlagDialogOpened} onClose={onCloseSkyFlagDialog} yOffset={getModalOffset(screenWidth)} >
      <SkyFlagDialog
        onClick={() => closeSkyFlagDialog()}
        onCancel={() => closeSkyFlagDialog()} />
    </Modal>
    <Modal opened={translationIntroOpened} onClose={() => setTranslationIntroOpened(false)} centered>
      <div className="text-center px-4 py-2">
        <div className="flex justify-center mb-2">
          <img src={iconEnToJpGray} alt="和訳" className="w-10 h-10" />
        </div>
        <div className="text-lg font-bold text-[#0c1f60] mb-3">日本語変換ボタン登場</div>
        <div className="text-sm text-[#0c1f60] leading-relaxed">
          英語プロンプトを日本語に変換できます。インスピレーション引用の編集がしやすくなりました。
        </div>
      </div>
    </Modal>
    <Modal opened={img2imgAgreeVisible} onClose={() => setImg2imgAgreeVisible(false)} centered>
      <div className="px-4 py-3 text-[#0c1f60]">
        <div className="text-lg font-bold mb-3">画像参照機能の注意事項</div>
        <div className="text-sm leading-relaxed mb-2">
          画像参照機能では、アップロードした画像素材をもとに生成が可能です。
        </div>
        <div className="text-sm font-bold mb-1">注意事項：</div>
        <div className="text-sm leading-relaxed mb-4">
          お客様がアップロードする画像が第三者の著作権を侵害していないことに同意したうえでご利用ください。
        </div>
        <Checkbox
          checked={img2imgAgreeChecked}
          onChange={(e) => setImg2imgAgreeChecked(e.currentTarget.checked)}
          disabled={img2imgAgreeLoading}
          className="mb-4"
          label="上記の注意事項に同意する"
        />
        <div className="flex flex-col">
          <button
            onClick={onAgreeImg2Img}
            disabled={!img2imgAgreeChecked || img2imgAgreeLoading}
            className="w-full px-4 py-2 rounded text-white font-bold disabled:opacity-60"
            style={{ background: "linear-gradient(91.51deg, #0000F3 0.07%, #F416BF 100.07%)" }}
          >
            {img2imgAgreeLoading ? <Loader type="dots" color="white" size="18px" className="mx-auto" /> : '画像アップロードを進める'}
          </button>
          <button
            onClick={() => setImg2imgAgreeVisible(false)}
            disabled={img2imgAgreeLoading}
            className="mt-3 text-sm text-gray-500 underline disabled:opacity-60"
          >
            キャンセル
          </button>
        </div>
      </div>
    </Modal>
    <Modal opened={generateIntroOpened} onClose={() => setGenerateIntroOpened(false)} centered>
      <div className="text-center px-4 py-2">
        <div className="flex justify-center mb-2">
          <div
            className="w-16 h-16 rounded-2xl flex items-center justify-center"
            style={{ background: "linear-gradient(91.51deg, #0000F3 0.07%, #F416BF 100.07%)" }}
          >
            <img src="/images/flare.png" alt="生成" className="w-10 h-10" />
          </div>
        </div>
        <div className="text-lg font-bold text-[#0c1f60] mb-3">生成ボタンがアップデート</div>
        <div className="text-sm text-[#0c1f60] leading-relaxed">
          日本語入力のままで画像生成が可能です。もちろん英語入力でも生成できます。
        </div>
      </div>
    </Modal>
  
    { cardProps !== undefined &&
    <CardRegistrationDialog clientSecret={cardProps?.clientSecret!} onClose={() => setCardProps(undefined)} />
    }
    <Toaster />
    <Modal size="auto" opened={loginDialogOpened} onClose={closeLoginDialog}>
      <LoginDialog onCancel={() => closeLoginDialog()}  onLogin={() => onLoginEvent()} isLogin={true} />
    </Modal>
    {modelSelectorOpened && (
      <div className="fixed inset-0 z-[400] bg-black/40 flex items-end sm:items-center sm:justify-center">
        <div className="w-full sm:w-[560px] bg-white rounded-t-[28px] sm:rounded-[20px] px-4 pt-4 pb-5">
          <div className="flex items-center justify-between">
            <div className="w-8"></div>
            <div className="text-[28px] sm:text-[24px] font-bold text-[#11175B]">モデルを選択</div>
            <button className="text-[#0A0F5E] text-[34px] sm:text-[26px] leading-none" onClick={() => setModelSelectorOpened(false)}>×</button>
          </div>
          <div className="mt-5 border-t border-[#ECEEF6]"></div>
          <div className="mt-3 space-y-2">
            <button
              type="button"
              disabled={!canSelectNanoBananaPro}
              className={`w-full text-left rounded-2xl px-2 py-2 flex items-start gap-2 ${
                canSelectNanoBananaPro
                  ? "hover:bg-[#F8F9FF] clickable"
                  : "cursor-not-allowed"
              } group`}
              onClick={() => {
                if (!canSelectNanoBananaPro) return;
                setGenerationModelType("nano-banana-pro");
                setModelSelectorOpened(false);
              }}
            >
              <img src={bananaIcon} alt="banana" className="w-7 h-7 object-contain mt-1" />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="inline-flex text-[11px] bg-[#FF4D4F] text-white font-bold px-2 py-0.5 rounded-full">NEW</span>
                  <span className="text-[18px] sm:text-[16px] text-[#262B3E]">Nano Banana Pro</span>
                </div>
                <div className="text-[13px] sm:text-[12px] text-[#8C92A8] mt-1">Googleが提供する最先端の画像生成モデル。「複数画像の組み合わせ」「テキスト出力」「高度な編集」など複雑なタスクに高い精度で対応可能。</div>
                {!canSelectNanoBananaPro && (
                  <div className="text-[12px] sm:text-[11px] text-[#F416BF] mt-0.5">
                    このプランでは利用できません。アップグレードをご検討ください。
                  </div>
                )}
              </div>
              <div className={`w-6 h-6 rounded-full border-2 mt-2 ${generationModelType === "nano-banana-pro" ? "border-[#3190FF]" : "border-[#D5D9E8]"}`}>
                {generationModelType === "nano-banana-pro" && <div className="w-3 h-3 bg-[#3190FF] rounded-full m-[4px]"></div>}
              </div>
            </button>
            <button
              type="button"
              className="w-full text-left rounded-2xl px-2 py-2 hover:bg-[#F8F9FF] flex items-start gap-2"
              onClick={() => { setGenerationModelType("nano-banana"); setModelSelectorOpened(false); }}
            >
              <img src={bananaIcon} alt="banana" className="w-7 h-7 object-contain mt-1" />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="inline-flex text-[11px] bg-[#FF4D4F] text-white font-bold px-2 py-0.5 rounded-full">NEW</span>
                  <div className="text-[18px] sm:text-[16px] text-[#262B3E]">Nano Banana</div>
                </div>
                <div className="text-[13px] sm:text-[12px] text-[#8C92A8] mt-1">Googleが提供する最先端の画像生成モデル。生成速度と手軽さが魅力。</div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 mt-2 ${generationModelType === "nano-banana" ? "border-[#3190FF]" : "border-[#D5D9E8]"}`}>
                {generationModelType === "nano-banana" && <div className="w-3 h-3 bg-[#3190FF] rounded-full m-[4px]"></div>}
              </div>
            </button>
            <button
              type="button"
              className="w-full text-left rounded-2xl px-2 py-2 hover:bg-[#F8F9FF] flex items-start gap-2"
              onClick={() => { setGenerationModelType("standard"); setModelSelectorOpened(false); }}
            >
              <img src="/images/stable-diffusion.png" alt="stable diffusion" className="w-7 h-7 mt-1 object-contain" />
              <div className="flex-1">
                <div className="text-[18px] sm:text-[16px] text-[#262B3E]">Stable Diffusion XL</div>
                <div className="text-[13px] sm:text-[12px] text-[#8C92A8] mt-1">Stability AIが提供する画像生成モデル。スピーディかつ多様な生成を実現。</div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 mt-2 ${generationModelType === "standard" ? "border-[#3190FF]" : "border-[#D5D9E8]"}`}>
                {generationModelType === "standard" && <div className="w-3 h-3 bg-[#3190FF] rounded-full m-[4px]"></div>}
              </div>
            </button>
          </div>
        </div>
      </div>
    )}
    <div className="block sm:flex sm:pt-4 sm:ml-2 min-w-0" style={{backgroundColor: '#eaeaea80'}}>

      <div
        id="center-cell"
        className="sm:ml-4 w-full sm:flex-1 sm:min-w-0 sm:rounded-md mb-0 sm:mb-12 pb-24 sm:pb-8"
        style={{ backgroundColor: '#ffffff', paddingTop: screenWidth < 640 ? mobileContentOffset : undefined }}
      >
        <div className="mt-0 sm:mt-4">
          <div className="hidden sm:block">
            <span className="ml-4 mt-4 text-2xl font-bold gradation-text">プロンプト入力</span>
          </div>
          
          {/* Mobile prompt sections */}
          <div
            ref={mobilePromptRef}
            className="sm:hidden fixed left-0 right-0 bg-[#f8f9fa] border-b border-gray-200 shadow-[0_8px_16px_rgba(0,0,0,0.12)] z-40"
            style={{ top: mobilePromptTop }}
          >
            <div className="max-h-[70vh] overflow-y-auto px-4 pt-3 pb-4">
              <div className="flex items-center justify-between mb-2 px-[2px]">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold">設定中のプロンプト</span>
                  {!isNanoModelSelected && (
                    <button
                      onClick={() => setMobileNegativeVisible(!mobileNegativeVisible)}
                      className="clickable"
                      aria-label="ネガティブプロンプトを表示"
                    >
                      <img 
                        src={mobileNegativeVisible ? "/images/icon/arrow-up.svg" : "/images/icon/arrow-down.svg"} 
                        className="w-[16px] h-[16px]"
                        alt={mobileNegativeVisible ? "閉じる" : "開く"}
                      />
                    </button>
                  )}
                </div>
                <button
                  onClick={clearAllPrompts}
                  className="clickable flex items-center justify-center w-7 h-7 rounded bg-white border border-gray-200"
                  aria-label="すべてクリア"
                >
                  <img src="/images/icon-close.svg" alt="クリア" className="w-[12px] h-[12px]" />
                </button>
              </div>
              <div className="p-[1px] rounded-lg" style={{ background: "linear-gradient(135deg, #4f46e5, #a855f7, #ec4899)" }}>
                <div className="bg-white rounded-lg p-3 shadow-[0_6px_18px_rgba(0,0,0,0.06)]">
                  <div className="flex flex-wrap gap-1 mb-2">
                    { selectedHint.filter((e) => e.isNegativePrompt === false).map((item) => (
                      buildSelectedSpan(item, false)
                    ))}
                  </div>
                  <div className="text-left text-primary relative">
                    <textarea
                      className="w-full border-0 outline-none focus:ring-0 resize-none text-base h-[48px] placeholder:text-gray-400"
                      value={additionalPrompt}
                      onChange={(e) => setAdditionalPrompt(e.target.value)}
                      placeholder="生成したい画像の指示を入力"
                    ></textarea>
                  </div>
                  <div className="mt-2 flex items-center gap-1">
                    <div className="flex items-center gap-1 text-gray-500 shrink-0">
                      <button
                        onClick={() => ensureImg2ImgAgreedThenPick()}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable relative overflow-hidden"
                      >
                        <img src={iconImageAdd} alt="画像追加" className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => updateMobileSettingsVisible(true)}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable"
                      >
                        <img src={iconAdjust} alt="詳細設定" className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => translatePrompt(true)}
                        disabled={isPromptTranslating}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable disabled:opacity-50"
                        title="JP -> EN"
                      >
                        { isPromptTranslating
                          ? <Loader type="dots" className="mx-auto" size="12px" />
                          : <img src={iconEnToJpGray} alt="EN→JP" className="w-4 h-4" />
                        }
                      </button>
                    </div>
                    <div className="flex-1 min-w-0 flex justify-start pl-1">
                      {buildModelSelector(true)}
                    </div>
                    <div className="flex items-center text-[14px] leading-none pr-[2px] shrink-0" style={{ fontWeight: 400 }}>
                      <img src="/images/icon/icons8-lightning.png" alt="消費クレジット" className="w-[14px] h-[14px] mr-[2px]" />
                      <span>{currentGenerationCreditCost ?? "-"}</span>
                    </div>
                    <button
                      onClick={() => { maybeOpenGenerateIntro(); buildImage(); }}
                      disabled={processing}
                      className="w-8 h-8 rounded-xl text-white font-bold flex items-center justify-center clickable disabled:opacity-50 shrink-0"
                      style={{ background: "linear-gradient(91.51deg, #0000F3 0.07%, #F416BF 100.07%)" }}
                    >
                      <img src="/images/flare.png" alt="生成" className="w-4 h-4" />
                    </button>
                  </div>
                  {buildSelectedInputImageRow()}
                </div>
              </div>

              {/* Negative prompt section - conditionally shown */}
              {!isNanoModelSelected && mobileNegativeVisible && (
                <>
                  <div className="text-sm mb-2 mt-4 flex items-center justify-between">
                    <span className="font-bold text-[#F416BF]">設定中のネガティブプロンプト</span>
                  </div>
                  <div className="p-[1px] rounded-lg border border-[#F416BF]">
                    <div className="bg-white rounded-lg p-3 shadow-[0_6px_18px_rgba(0,0,0,0.06)]">
                      <div className="flex flex-wrap gap-1 mb-2">
                        { selectedHint.filter((e) => e.isNegativePrompt === true).map((item) => (
                          buildSelectedSpan(item, true)
                        ))}
                      </div>
                      <div className="text-left text-primary relative">
                        <textarea
                          placeholder="生成結果から除きたい要素があれば入力"
                          className="w-full border-0 outline-none focus:ring-0 resize-none text-base h-[48px] placeholder:text-gray-400 rounded-md"
                          value={additionalNegativePrompt}
                          onChange={(e) => setAdditionalNegativePrompt(e.target.value)}
                        ></textarea>
                      </div>
                      <div className="flex items-center mt-1">
                        <div className="flex items-center gap-2 text-gray-500">
                        <button
                          onClick={() => { maybeOpenGenerateIntro(); translatePrompt(false); }}
                          disabled={isNegativePromptTranslating}
                          className="w-9 h-9 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable disabled:opacity-50"
                          title="EN -> JP"
                        >
                            { isNegativePromptTranslating
                              ? <Loader type="dots" className="mx-auto" size="14px" />
                              : <img src={iconEnToJpGray} alt="EN→JP" className="w-5 h-5" />
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Desktop prompt panel (same parts as SP) */}
          <div className="hidden sm:block px-4 mt-3">
            <div className="max-h-[70vh] overflow-y-auto pt-1 pb-2">
              <div className="flex items-center justify-between mb-2 px-[2px]">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold">設定中のプロンプト</span>
                  {!isNanoModelSelected && (
                    <button
                      onClick={() => setMobileNegativeVisible(!mobileNegativeVisible)}
                      className="clickable"
                      aria-label="ネガティブプロンプトを表示"
                    >
                      <img
                        src={mobileNegativeVisible ? "/images/icon/arrow-up.svg" : "/images/icon/arrow-down.svg"}
                        className="w-[16px] h-[16px]"
                        alt={mobileNegativeVisible ? "閉じる" : "開く"}
                      />
                    </button>
                  )}
                </div>
                <button
                  onClick={clearAllPrompts}
                  className="clickable flex items-center justify-center w-7 h-7 rounded bg-white border border-gray-200"
                  aria-label="すべてクリア"
                >
                  <img src="/images/icon-close.svg" alt="クリア" className="w-[12px] h-[12px]" />
                </button>
              </div>
              <div className="p-[1px] rounded-lg" style={{ background: "linear-gradient(135deg, #4f46e5, #a855f7, #ec4899)" }}>
                <div className="bg-white rounded-lg p-3 shadow-[0_6px_18px_rgba(0,0,0,0.06)]">
                  <div className="flex flex-wrap gap-1 mb-2">
                    { selectedHint.filter((e) => e.isNegativePrompt === false).map((item) => (
                      buildSelectedSpan(item, false)
                    ))}
                  </div>
                  <div className="text-left text-primary relative">
                    <textarea
                      className="w-full border-0 outline-none focus:ring-0 resize-none text-base h-[48px] placeholder:text-gray-400"
                      value={additionalPrompt}
                      onChange={(e) => setAdditionalPrompt(e.target.value)}
                      placeholder="生成したい画像の指示を入力"
                    ></textarea>
                  </div>
                  <div className="mt-2 flex items-center gap-1">
                    <div className="flex items-center gap-1 text-gray-500 justify-start shrink-0">
                      <button
                        onClick={() => ensureImg2ImgAgreedThenPick()}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable relative overflow-hidden"
                      >
                        <img src={iconImageAdd} alt="画像追加" className="w-4 h-4" />
                      </button>
                      {buildSelectedInputImageRow(true)}
                      <button
                        onClick={() => document.getElementById('generation-settings')?.scrollIntoView({ behavior: 'smooth' })}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable"
                      >
                        <img src={iconAdjust} alt="詳細設定" className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => translatePrompt(true)}
                        disabled={isPromptTranslating}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable disabled:opacity-50"
                        title="JP -> EN"
                      >
                        { isPromptTranslating
                          ? <Loader type="dots" className="mx-auto" size="12px" />
                          : <img src={iconEnToJpGray} alt="EN→JP" className="w-4 h-4" />
                        }
                      </button>
                    </div>
                    <div className="flex-1 min-w-0 flex justify-start px-1">
                      {buildModelSelector(true)}
                    </div>
                    <div className="flex items-center text-[14px] leading-none pr-[2px] shrink-0" style={{ fontWeight: 400 }}>
                      <img src="/images/icon/icons8-lightning.png" alt="消費クレジット" className="w-[14px] h-[14px] mr-[2px]" />
                      <span>{currentGenerationCreditCost ?? "-"}</span>
                    </div>
                    <button
                      onClick={() => { maybeOpenGenerateIntro(); buildImage(); }}
                      disabled={processing}
                      className="w-8 h-8 rounded-xl text-white font-bold flex items-center justify-center clickable disabled:opacity-50 shrink-0"
                      style={{ background: "linear-gradient(91.51deg, #0000F3 0.07%, #F416BF 100.07%)" }}
                    >
                      <img src="/images/flare.png" alt="生成" className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>

              {!isNanoModelSelected && mobileNegativeVisible && (
                <>
                  <div className="text-sm mb-2 mt-4 flex items-center justify-between">
                    <span className="font-bold text-[#F416BF]">設定中のネガティブプロンプト</span>
                  </div>
                  <div className="p-[1px] rounded-lg border border-[#F416BF]">
                    <div className="bg-white rounded-lg p-3 shadow-[0_6px_18px_rgba(0,0,0,0.06)]">
                      <div className="flex flex-wrap gap-1 mb-2">
                        { selectedHint.filter((e) => e.isNegativePrompt === true).map((item) => (
                          buildSelectedSpan(item, true)
                        ))}
                      </div>
                      <div className="text-left text-primary relative">
                        <textarea
                          placeholder="生成結果から除きたい要素があれば入力"
                          className="w-full border-0 outline-none focus:ring-0 resize-none text-base h-[48px] placeholder:text-gray-400 rounded-md"
                          value={additionalNegativePrompt}
                          onChange={(e) => setAdditionalNegativePrompt(e.target.value)}
                        ></textarea>
                      </div>
                      <div className="flex items-center mt-1">
                        <div className="flex items-center gap-2 text-gray-500">
                          <button
                            onClick={() => { maybeOpenGenerateIntro(); translatePrompt(false); }}
                            disabled={isNegativePromptTranslating}
                            className="w-9 h-9 rounded-lg border border-gray-200 bg-white flex items-center justify-center clickable disabled:opacity-50"
                            title="EN -> JP"
                          >
                            { isNegativePromptTranslating
                              ? <Loader type="dots" className="mx-auto" size="14px" />
                              : <img src={iconEnToJpGray} alt="EN→JP" className="w-5 h-5" />
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          
          {generationModelType === "standard" &&
            <>
              <div className="ml-4 mt-2 text-lg font-bold flex items-center">
                <span className="text-[16px]">モデルのテイストを選ぶ</span>
                <Tooltip label="作成したい画像の作風や表現のテイストを選びましょう。">
                  <img src="/images/icon/icon-help.svg" className="w-[18px] h-[18px] clickable ml-2"></img>
                </Tooltip>
              </div>
              <div className="overflow-x-auto ml-4 mr-4 max-w-full">
                <div className="flex ml-4" style={{ overflowX: "auto" }}>
                { mainTasteList.map((e) => (
                  buildTasteImage(e)
                ))}
                </div>
              </div>
            </>
          }
        </div>

        <div className="hidden" id="image-uploader-anchor">
          <ImageUploader
            ref={imageUploaderRef}
            onBase64Change={(base64) => onSetBase64(base64)}
            multiple={generationModelType === "nano-banana" || generationModelType === "nano-banana-pro"}
            showSelectedPreview={false}
          />
        </div>

        <div id="inspiration-section">
          <div className="flex justify-between ml-4 mt-4 mr-4">
            <span className="text-lg font-bold flex items-center">
              <span className="text-[16px] font-bold">インスピレーションを得る</span>
              <Tooltip label="膨大な画像コレクションから構図やプロンプトのアイデアを得ましょう。">
                <img src="/images/icon/icon-help.svg" className="w-[18px] h-[18px] clickable ml-2"></img>
              </Tooltip>
            </span>

            <a href="/inspiration" className="flex items-center text-xs text-gray-500 clickable">もっと見る <img src="/images/icon/icon-right.svg" className="w-[16px] h-[16px]"></img></a>
          </div>
          <div className="overflow-x-auto ml-4 mr-4 max-w-full">
            <div className="flex items-center" style={{ width: "max-content"}}>
              { inspirationList.map((e) => (
                <div key={`inspiration-${e.uid}`} className="mx-2 my-2" onClick={(elem) => onSelectInspiration(e)}>
                  <img loading="lazy" className="clickable h-[200px]" style={{ borderRadius: "8px"}} src={`${process.env.REACT_APP_IMAGE_URL}/sample/${e.imageFileName}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-0 sm:border mx-1 sm:mx-4 pt-2 pb-2 mt-4 rounded-xl">
          <div className="flex justify-between items-center border-b border-gray-200">
            <div className="flex">
              <button
                className={`px-1 sm:px-6 py-2 sm:py-3 font-bold text-xs sm:text-lg transition-colors ${
                  !openedNegative ? 'text-[#0909FF] border-b-2 border-[#0909FF]' : 'text-gray-500'
                }`}
                onClick={() => { if(openedNegative) toggleNegative(); }}
              >
                <span className="flex items-center flex-wrap sm:flex-nowrap">
                  <img src="/images/icon/circle-plus-blue.svg" className="w-[14px] h-[14px] sm:w-[20px] sm:h-[20px] mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="leading-tight">プロンプトを選ぶ</span>
                </span>
              </button>
              <button
                className={`px-1 sm:px-6 py-2 sm:py-3 font-bold text-xs sm:text-lg transition-colors ${
                  openedNegative ? 'text-[#F416BF] border-b-2 border-[#F416BF]' : 'text-gray-500'
                }`}
                onClick={() => { toggleNegative(); }}
              >
                <span className="flex items-center flex-wrap sm:flex-nowrap">
                  <img src="/images/icon/circle-plus-red.svg" className="w-[14px] h-[14px] sm:w-[20px] sm:h-[20px] mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="leading-tight">ネガティブプロンプトを選ぶ</span>
                </span>
              </button>
            </div>
          </div>

          <div id="prompt-section" className={`${openedNegative ? 'hidden' : ''}`}>
            <div className="p-4">
              <div className="w-full box-border">
                <div className="relative">
                  <input value={searchText} type="text" onChange={(e) => onChangeSearchText(e.target.value)} className="border rounded box-border w-full pl-8 py-1" placeholder="任意のキーワードを入力 > 表示候補を選択"></input>
                  <img src="/images/icon/icon-search.svg" className="w-[20px] h-[20px] absolute left-2 top-2" />
                </div>
                { promptSearchResult.length >= 1 &&
                <div className="rounded border pl-2 mt-1 min-w-[240px] absolute bg-white z-10">
                  { promptSearchResult!.map((e) => (
                    <>
                    <div>{buildSearchOption(e)}</div>
                    </>
                  ))}
                </div>
                }
              </div>

              <div className="mt-4">
                { largeCategories && largeCategories!.map((largeCategory) => (
                  <>
                    <div className="text-lg mt-6">
                      <span className="font-bold">{largeCategory}</span>
                      <span onClick={(e) => setSelectedLargeCategory(largeCategory)} className="ml-4 text-sm text-gray text-[#868E96] clickable">{"> もっと見る"}</span>
                    </div>
                    <div className="max-w-full">
                      { hintList.filter((e) => e.largeCategory === largeCategory && e.isPickup === true).map((item) => (
                        buildHintSpan(item, false)
                      ))}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>

      <div id="negative-prompt-section" className={`${!openedNegative ? 'hidden' : ''}`}>
            <div className="p-4">
              
              
              <div className="w-full box-border">
                <div className="relative">
                  <input value={negativeSearchText} type="text" onChange={(e) => onChangeNegativeSearchText(e.target.value)} className="border rounded box-border w-full pl-8 py-1" placeholder="任意のキーワードを入力 > 表示候補を選択"></input>
                  <img src="/images/icon/icon-search.svg" className="w-[20px] h-[20px] absolute left-2 top-2" />
                </div>
                { negativePromptSearchResult.length >= 1 &&
                <div className="rounded border pl-2 mt-1 min-w-[240px] absolute bg-white z-10">
                  { negativePromptSearchResult!.map((e) => (
                    <>
                    <div>{buildSearchOption(e)}</div>
                    </>
                  ))}
                </div>
                }
              </div>

              <div className="mt-4">
                { negativelargeCategories && negativelargeCategories!.map((largeCategory) => (
                  <>
                    <div className="text-lg mt-6">
                      <span className="font-bold">{largeCategory}</span>
                      <span onClick={(e) => setSelectedLargeCategory(largeCategory)} className="ml-4 text-sm text-gray text-[#868E96] clickable">{"> もっと見る"}</span>
                    </div>
                    <div className="max-w-full">
                      { negativeHintList.filter((e) => e.largeCategory === largeCategory && e.isPickup === true).map((item) => (
                        buildHintSpan(item, true)
                      ))}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
      </div>
              {/* Mobile SkyFlag Banner */
              }
      <div className="sm:hidden">
        <a href={`${getSkyFlagUrl()}`} target="_blank" onClick={() => {
          const url = getSkyFlagUrl();
          console.log('[AppBanner] Click (mobile):', url);
        }}>
          <img src="/images/skyflag-banner2.png" className="w-full border-0" style={{border: 'none', outline: 'none'}}></img>
        </a>
      </div>


      </div>


      <div>
      <div id="right-cell-top" className="hidden w-[420px] min-w-[420px] ml-2 mr-4">
        <div className="w-[420px] min-w-[420px] ml-2 pl-4 pr-4 pt-2 mr-4 pb-2" style={{backgroundColor: '#03034F', color: "#fff", borderRadius: "8px"}}>
          <div className="flex justify-between mt-4">
            <span className="font-bold text-lg">画像生成</span>
            <span onClick={clearSettings} className="text-sm clickable">すべての設定をクリア</span>
          </div>
          <div className="text-sm mt-1 mb-1 flex items-center justify-between">
            <span className="flex items-center">
              <span>設定中のプロンプト</span>
              <Tooltip label="選択中のアイテムをタップするとプロンプトを強調できます。">
                <img src="/images/icon/icon-help-white.svg" className="w-[16px] h-[16px] clickable ml-1"></img>
              </Tooltip>
            </span>
            <div className="flex items-center gap-2">
              { isPromptTranslating === false &&
              <button onClick={() => translatePrompt(true)} className="clickable flex items-center justify-center w-8 h-8 rounded">
                <img src={iconEnToJpGray} alt="和訳" className="w-[16px] h-[16px]" />
              </button>
              }
              { isPromptTranslating === true &&
              <span className="clickable flex w-[70px] text-xs text-white border border-white rounded px-2 py-[2px]">
                <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
              </span>
              }
              <span className="text-sm clickable" onClick={() => clearPromptHint()}>クリア</span>
            </div>
          </div>
          <div>
            { selectedHint.filter((e) => e.isNegativePrompt === false).map((item) => (
              buildSelectedSpan(item, false)
            ))}
          </div>
          <div className="text-left mt-1 text-primary relative">
            <textarea className="w-full border py-1 px-2 resize-none text-sm h-[48px]"
             value={additionalPrompt} onChange={(e) => setAdditionalPrompt(e.target.value)} 
              placeholder="プロンプトを手動で入力。英語が推奨です。"></textarea>
          </div>
          {buildModelSelector(false)}

          <div className="text-sm mb-1 mt-2 flex items-center justify-between">
            <span>設定中のネガティブプロンプト</span>
            <div className="flex items-center gap-2">
              { isNegativePromptTranslating === false &&
              <button onClick={() => { maybeOpenGenerateIntro(); translatePrompt(false); }} className="clickable flex items-center justify-center w-8 h-8 rounded">
                <img src={iconEnToJpGray} alt="和訳" className="w-[16px] h-[16px]" />
              </button>
              }
              { isNegativePromptTranslating === true &&
              <span className="clickable flex w-[70px] text-xs text-white border border-white rounded px-2 py-[2px]">
                <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
              </span>
              }
              <span className="text-sm clickable" onClick={() => clearNegativePromptHint()}>クリア</span>
            </div>
          </div>
          { selectedHint.filter((e) => e.isNegativePrompt === true).map((item) => (
            buildSelectedSpan(item, true)
          ))}
          <div className="text-left mt-2 text-primary relative">
            <textarea placeholder="生成結果から除きたい要素があれば入力" className="w-full border-0 py-1 px-2 resize-none text-sm h-[48px]" value={additionalNegativePrompt} onChange={(e) => setAdditionalNegativePrompt(e.target.value)} ></textarea>
          </div>
          <div className="text-center mt-4">
            <Button size="lg" fullWidth disabled={processing} className="text-primary gradation-button hover-button rounded bg-white w-full" style={{ border: "1px solid gray" }} onClick={() => { maybeOpenGenerateIntro(); buildImage(); }}>
              <img className="h-[20px] mr-1" src="/images/flare.png"></img>
              <span className="font-bold">画像生成する</span>
            </Button>
            <div className="text-xs mt-4 mb-2">
              <span>イメージが湧かない時は、</span>
              <a href="/inspiration" className="border-b">画像集からインスピレーションを得ましょう</a>
            </div>
          </div>
        </div>
      </div>
      
      <div id="generation-settings" className="hidden sm:block mt-1 sm:mt-0 pl-4 sm:mr-4 bg-[#fff] sm:bg-[unset]">
        <div className="w-full sm:w-[420px] sm:min-w-[420px] ml-0 pb-2 sm:ml-0 sm:pl-4 pr-4 sm:mr-4 sm:mt-0 pt-2 sm:rounded-md" style={{backgroundColor: '#fff'}}>
            <div className="font-bold">生成画像設定</div>
            <div>
              <label className="text-sm">画像の比率</label>
              <div className="flex justify-between">
              <Radio.Group value={aspectRatio} onChange={(e) => setAspectRatio(e)}>
                <Group>
              { aspectRatioOptionsForCurrentModel.map((e) => (
                buildAspectRatioOption(e)
                // <span onClick={() => setAspectRatio(e.ratio!)} style={{ border: "1px solid gray", color: aspectRatio === e.ratio ? 'blue' : '', borderColor: aspectRatio === e.ratio ? 'blue' : '', }} className={`clickable rounded text-sm px-2 mr-2`}>{e.ratio}</span>
                ))}
                </Group>
              </Radio.Group>
              </div>
              <div></div>
            </div>

            {generationModelType === "nano-banana-pro" && (
              <div className="mt-4">
                <label className="text-sm">画像サイズ</label>
                <div className="">
                  <Radio.Group value={imageSize} onChange={(e) => setImageSize(e)}>
                    <Group>
                      { nanoProImageSizeList.map((size) => (
                        <Radio
                          color="#0909FF"
                          key={`nano-pro-size-${size}`}
                          label={size}
                          value={size}
                          disabled={!allowedNanoProImageSizes.includes(size)}
                        ></Radio>
                      ))}
                    </Group>
                  </Radio.Group>
                </div>
                <div></div>
              </div>
            )}

            { isStandardGenerationModel && openedDetail === false &&
              <div className="pb-2">
                <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                  <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                    詳細設定
                    <img src="/images/icon/arrow-down.svg" className="w-[16px] h-[16px]"></img>
                  </span>
                </div>
              </div>
            }

            <Collapse in={isStandardGenerationModel && openedDetail}>
              <>
              <div className="mt-4">
                <label className="text-sm">画像のフォーマット</label>
                <div className="">
                <Radio.Group value={fileFomat} onChange={(e) => setFileFomat(e)}>
                  <Group>
                    { fileFormatList.map((e) => (
                      <Radio color="#0909FF" key={`format-${e}`} label={e} value={e}></Radio>
                    ))}
                  </Group>
                </Radio.Group>
                </div>
                <div></div>
              </div>

              <div className="relative">
                <div className="mt-4">
                  <label className="text-sm">生成画像数</label>
                  <div className="">
                  <Radio.Group value={bulkCount.toString()} onChange={(e) => setBulkCount(parseInt(e))}>
                    <Group>
                      { bulkCountOption.map((e) => (
                        <Radio color="#0909FF" key={`bulk-${e}`} label={e.toString()} value={e.toString()}></Radio>
                      ))}
                    </Group>
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">シード値</label>
                    <Tooltip label="画像生成した際にランダム生成される値です。同じシード値とプロンプトを使うと同じ画像を再現できます。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <NumberInput hideControls placeholder="シード値を手動入力" value={seed} onChange={(e) => setSeed(e.toString())}></NumberInput>
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">ステップ数 (10 ~ 40)</label>
                    <Tooltip label="生成画像ノイズを除去する回数です。ステップ数が多いほど高品質な画像が生成される一方で処理時間が長くなります。デフォルト値20が推奨です。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                  <Slider color="#0909FF" min={10} max={40} defaultValue={stepCount} onChange={(e) => setStepCount(e)} marks={[{ value: 10 }, { value: 20 }, { value: 30 }, { value: 40 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">スケール (3 ~ 10)</label>
                    <Tooltip label="プロンプトに対する生成画像の忠実度を調整できます。スケールを大きくするほど忠実度が向上します。7前後が推奨です。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <Slider color="#0909FF" min={3} max={10} step={0.1} defaultValue={scale} onChange={(e) => setScale(e)} marks={[{ value: 3 }, { value: 5.5 }, { value: 8 }, { value: 10 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4 mb-4">
                  <div className="flex items-center">
                    <label className="text-sm">img2img ノイズ除去の強度(0.1 ~ 1.0)</label>
                    <Tooltip multiline className="max-w-[300px]" label={`ノイズ除去の強度（Denoising strength）設定で画像の忠実度を調整できます。０に近いほど元画像に忠実な画像が生成され、１に近いほどプロンプトにならったオリジナル性の高い画像が生成されます。推奨は0.7-0.8です。`}>
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <Slider color="#0909FF" min={0.1} max={1} step={0.01} defaultValue={strength} onChange={(e) => setStrength(e)} marks={[{ value: 0.25 }, { value: 0.5 }, { value: 0.75 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">img2img 画像リサイズ</label>
                    <Tooltip multiline className="max-w-[300px]" label={`img2imgのアップロード画像と生成画像の指定サイズが異なる場合の補正方法を選択できます。[推奨]Resize and fillは縦横比維持で不足部分を補完します。Just resizeは縦横比無視で引き伸ばします。Just resize latent upscalerでは、縦横比無視の引き伸ばしかつ高解像度化します。Crop and resizeは縦横比維持で一部を切り取り補正します。`}>
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                  <Radio.Group variant="vertical" value={resizeMode} onChange={(e) => setResizeMode(e)}>
                    { resizeModeList.map((e) => (
                      <Radio color="#0909FF" key={`format-${e}`} className="mb-1" label={e.label} value={e.value}></Radio>
                    ))}
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                { subscription?.internalProductId === 'free' &&
                <div className="absolute top-[0px] bg-[#ffffffdd] z-[10] w-full">
                  <div className="text-center h-[320px] mt-[90px]">
                    <span className="text-sm text-[#F416BF] font-bold mt-[120px]">2以上の同時画像生成、シード値入力、ステップ数、スケール<br/>
                    これらの機能はLiteプラン以上でお使いいただけます。</span>
                  </div>
                </div>
                }
              </div>
              </>
              </Collapse>

              { isStandardGenerationModel && openedDetail === true &&
              <div className="pb-2 pt-1">
                <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                  <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                    閉じる
                    <img src="/images/icon/arrow-up.svg" className="w-[12px] h-[12px] ml-1"></img>
                  </span>
                </div>
              </div>
              }
          </div>
        </div>

        {/* Mobile Settings Modal */}
        {mobileSettingsVisible && (
          <div className="sm:hidden fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
            <div className="w-full bg-white rounded-t-lg max-h-[80vh] transition-transform duration-300 ease-out transform translate-y-0 flex flex-col">
              <div className="bg-white border-b p-4 flex justify-between items-center rounded-t-lg">
                <h3 className="text-lg font-bold">生成画像設定</h3>
                <button 
                  onClick={() => updateMobileSettingsVisible(false)}
                  className="p-2 clickable"
                >
                  <img src="/images/icon-close.svg" className="w-[24px] h-[24px]" alt="閉じる" />
                </button>
              </div>
              <div className="p-4 pb-32 overflow-y-auto flex-1">
                <div>
                  <label className="text-sm">画像の比率</label>
                  <div className="grid grid-cols-3 gap-2 mt-1">
                  <Radio.Group value={aspectRatio} onChange={(e) => setAspectRatio(e)}>
                    <Group className="contents">
                  { aspectRatioOptionsForCurrentModel.map((e) => (
                    buildAspectRatioOption(e)
                    ))}
                    </Group>
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                {generationModelType === "nano-banana-pro" && (
                  <div className="mt-4">
                    <label className="text-sm">画像サイズ</label>
                    <div className="">
                      <Radio.Group value={imageSize} onChange={(e) => setImageSize(e)}>
                        <Group>
                          { nanoProImageSizeList.map((size) => (
                            <Radio
                              color="#0909FF"
                              key={`mobile-nano-pro-size-${size}`}
                              label={size}
                              value={size}
                              disabled={!allowedNanoProImageSizes.includes(size)}
                            ></Radio>
                          ))}
                        </Group>
                      </Radio.Group>
                    </div>
                    <div></div>
                  </div>
                )}
                { isStandardGenerationModel && openedDetail === false &&
                  <div className="pb-2">
                    <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                      <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                        詳細設定
                        <img src="/images/icon/arrow-down.svg" className="w-[16px] h-[16px]"></img>
                      </span>
                    </div>
                  </div>
                }

                <Collapse in={isStandardGenerationModel && openedDetail}>
                  <>
                  <div className="mt-4">
                    <label className="text-sm">画像のフォーマット</label>
                    <div className="">
                    <Radio.Group value={fileFomat} onChange={(e) => setFileFomat(e)}>
                      <Group>
                        { fileFormatList.map((e) => (
                          <Radio color="#0909FF" key={`format-${e}`} label={e} value={e}></Radio>
                        ))}
                      </Group>
                    </Radio.Group>
                    </div>
                    <div></div>
                  </div>

                  <div className="relative">
                    <div className="mt-4">
                      <label className="text-sm">生成画像数</label>
                      <div className="">
                      <Radio.Group value={bulkCount.toString()} onChange={(e) => setBulkCount(parseInt(e))}>
                        <Group>
                          { bulkCountOption.map((e) => (
                            <Radio color="#0909FF" key={`bulk-${e}`} label={e.toString()} value={e.toString()}></Radio>
                          ))}
                        </Group>
                      </Radio.Group>
                      </div>
                      <div></div>
                    </div>
                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">シード値</label>
                        <Tooltip label="画像生成した際にランダム生成される値です。同じシード値とプロンプトを使うと同じ画像を再現できます。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <NumberInput hideControls placeholder="シード値を手動入力" value={seed} onChange={(e) => setSeed(e.toString())}></NumberInput>
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">ステップ数 (10 ~ 40)</label>
                        <Tooltip label="生成画像ノイズを除去する回数です。ステップ数が多いほど高品質な画像が生成される一方で処理時間が長くなります。デフォルト値20が推奨です。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                      <Slider color="#0909FF" min={10} max={40} defaultValue={stepCount} onChange={(e) => setStepCount(e)} marks={[{ value: 10 }, { value: 20 }, { value: 30 }, { value: 40 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">スケール (3 ~ 10)</label>
                        <Tooltip label="プロンプトに対する生成画像の忠実度を調整できます。スケールを大きくするほど忠実度が向上します。7前後が推奨です。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <Slider color="#0909FF" min={3} max={10} step={0.1} defaultValue={scale} onChange={(e) => setScale(e)} marks={[{ value: 3 }, { value: 5.5 }, { value: 8 }, { value: 10 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4 mb-4">
                      <div className="flex items-center">
                        <label className="text-sm">img2img ノイズ除去の強度(0.1 ~ 1.0)</label>
                        <Tooltip multiline className="max-w-[300px]" label={`ノイズ除去の強度（Denoising strength）設定で画像の忠実度を調整できます。０に近いほど元画像に忠実な画像が生成され、１に近いほどプロンプトにならったオリジナル性の高い画像が生成されます。推奨は0.7-0.8です。`}>
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <Slider color="#0909FF" min={0.1} max={1} step={0.01} defaultValue={strength} onChange={(e) => setStrength(e)} marks={[{ value: 0.25 }, { value: 0.5 }, { value: 0.75 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">img2img 画像リサイズ</label>
                        <Tooltip multiline className="max-w-[300px]" label={`img2imgのアップロード画像と生成画像の指定サイズが異なる場合の補正方法を選択できます。[推奨]Resize and fillは縦横比維持で不足部分を補完します。Just resizeは縦横比無視で引き伸ばします。Just resize latent upscalerでは、縦横比無視の引き伸ばしかつ高解像度化します。Crop and resizeは縦横比維持で一部を切り取り補正します。`}>
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                      <Radio.Group variant="vertical" value={resizeMode} onChange={(e) => setResizeMode(e)}>
                        { resizeModeList.map((e) => (
                          <Radio color="#0909FF" key={`format-${e}`} className="mb-1" label={e.label} value={e.value}></Radio>
                        ))}
                      </Radio.Group>
                      </div>
                      <div></div>
                    </div>

                    { subscription?.internalProductId === 'free' &&
                    <div className="absolute top-[0px] bg-[#ffffffdd] z-[10] w-full">
                      <div className="text-center h-[320px] mt-[90px]">
                        <span className="text-sm text-[#F416BF] font-bold mt-[120px]">2以上の同時画像生成、シード値入力、ステップ数、スケール<br/>
                        これらの機能はLiteプラン以上でお使いいただけます。</span>
                      </div>
                    </div>
                    }
                  </div>
                  </>
                  </Collapse>

                  { isStandardGenerationModel && openedDetail === true &&
                  <div className="pb-2 pt-1">
                    <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                      <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                        閉じる
                        <img src="/images/icon/arrow-up.svg" className="w-[12px] h-[12px] ml-1"></img>
                      </span>
                    </div>
                  </div>
                  }
              </div>
            </div>
          </div>
        )}

        <div id="generation-history" className="hidden sm:block pl-2 sm:pl-0 pr-2 sm:pr-0 sm:ml-6 mt-4 sm:max-w-[400px] w-full box-border mb-[320px] sm:mb-6">
        { isLoggedIn === true &&
            <>
            <div className="font-bold text-lg flex justify-between">
              <span>生成履歴</span>
              <a href="/generation-history" className="flex items-center text-sm text-gray-500">もっと見る<img src="/images/icon/icon-right.svg" className="w-[16px] h-[16px]"></img></a>
            </div>
            <div className="flex flex-wrap -mx-0.5">
            { buildUnifiedHistoryItems() }
            </div>
            <div className="mt-6">
              <a href={`${getSkyFlagUrl()}`} target="_blank" onClick={() => {
                const url = getSkyFlagUrl();
                console.log('[AppBanner] Click (right-col):', url);
              }}>
                <img src="/images/skyflag-banner2.png" className="w-full"></img>
              </a>
            </div>
            </>
          }
        </div>
      </div>


    </div>
    <FooterMenu />
  </>;
}
